/* Earlsmere label designer — generated bundle. Edit src/*.js and re-run build/build.py. */
(function(){
/* Generated lookup tables - do not hand-edit. Source: python-barcode + qrcode. */
var C128_CODES = ["11011001100", "11001101100", "11001100110", "10010011000", "10010001100", "10001001100", "10011001000", "10011000100", "10001100100", "11001001000", "11001000100", "11000100100", "10110011100", "10011011100", "10011001110", "10111001100", "10011101100", "10011100110", "11001110010", "11001011100", "11001001110", "11011100100", "11001110100", "11101101110", "11101001100", "11100101100", "11100100110", "11101100100", "11100110100", "11100110010", "11011011000", "11011000110", "11000110110", "10100011000", "10001011000", "10001000110", "10110001000", "10001101000", "10001100010", "11010001000", "11000101000", "11000100010", "10110111000", "10110001110", "10001101110", "10111011000", "10111000110", "10001110110", "11101110110", "11010001110", "11000101110", "11011101000", "11011100010", "11011101110", "11101011000", "11101000110", "11100010110", "11101101000", "11101100010", "11100011010", "11101111010", "11001000010", "11110001010", "10100110000", "10100001100", "10010110000", "10010000110", "10000101100", "10000100110", "10110010000", "10110000100", "10011010000", "10011000010", "10000110100", "10000110010", "11000010010", "11001010000", "11110111010", "11000010100", "10001111010", "10100111100", "10010111100", "10010011110", "10111100100", "10011110100", "10011110010", "11110100100", "11110010100", "11110010010", "11011011110", "11011110110", "11110110110", "10101111000", "10100011110", "10001011110", "10111101000", "10111100010", "11110101000", "11110100010", "10111011110", "10111101110", "11101011110", "11110101110", "11010000100", "11010010000", "11010011100"];
var C128_STOP = "1100011101011";
var EAN_A = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"];
var EAN_B = ["0100111", "0110011", "0011011", "0100001", "0011101", "0111001", "0000101", "0010001", "0001001", "0010111"];
var EAN_C = ["1110010", "1100110", "1101100", "1000010", "1011100", "1001110", "1010000", "1000100", "1001000", "1110100"];
var EAN_PARITY = ["AAAAAA", "AABABB", "AABBAB", "AABBBA", "ABAABB", "ABBAAB", "ABBBAA", "ABABAB", "ABABBA", "ABBABA"];
var EAN_EDGE = "101", EAN_MIDDLE = "01010";
var QR_RS = {"L": [[[26, 19]], [[44, 34]], [[70, 55]], [[100, 80]], [[134, 108]], [[86, 68], [86, 68]], [[98, 78], [98, 78]], [[121, 97], [121, 97]], [[146, 116], [146, 116]], [[86, 68], [86, 68], [87, 69], [87, 69]], [[101, 81], [101, 81], [101, 81], [101, 81]], [[116, 92], [116, 92], [117, 93], [117, 93]], [[133, 107], [133, 107], [133, 107], [133, 107]], [[145, 115], [145, 115], [145, 115], [146, 116]], [[109, 87], [109, 87], [109, 87], [109, 87], [109, 87], [110, 88]]], "M": [[[26, 16]], [[44, 28]], [[70, 44]], [[50, 32], [50, 32]], [[67, 43], [67, 43]], [[43, 27], [43, 27], [43, 27], [43, 27]], [[49, 31], [49, 31], [49, 31], [49, 31]], [[60, 38], [60, 38], [61, 39], [61, 39]], [[58, 36], [58, 36], [58, 36], [59, 37], [59, 37]], [[69, 43], [69, 43], [69, 43], [69, 43], [70, 44]], [[80, 50], [81, 51], [81, 51], [81, 51], [81, 51]], [[58, 36], [58, 36], [58, 36], [58, 36], [58, 36], [58, 36], [59, 37], [59, 37]], [[59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [59, 37], [60, 38]], [[64, 40], [64, 40], [64, 40], [64, 40], [65, 41], [65, 41], [65, 41], [65, 41], [65, 41]], [[65, 41], [65, 41], [65, 41], [65, 41], [65, 41], [66, 42], [66, 42], [66, 42], [66, 42], [66, 42]]], "Q": [[[26, 13]], [[44, 22]], [[35, 17], [35, 17]], [[50, 24], [50, 24]], [[33, 15], [33, 15], [34, 16], [34, 16]], [[43, 19], [43, 19], [43, 19], [43, 19]], [[32, 14], [32, 14], [33, 15], [33, 15], [33, 15], [33, 15]], [[40, 18], [40, 18], [40, 18], [40, 18], [41, 19], [41, 19]], [[36, 16], [36, 16], [36, 16], [36, 16], [37, 17], [37, 17], [37, 17], [37, 17]], [[43, 19], [43, 19], [43, 19], [43, 19], [43, 19], [43, 19], [44, 20], [44, 20]], [[50, 22], [50, 22], [50, 22], [50, 22], [51, 23], [51, 23], [51, 23], [51, 23]], [[46, 20], [46, 20], [46, 20], [46, 20], [47, 21], [47, 21], [47, 21], [47, 21], [47, 21], [47, 21]], [[44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [44, 20], [45, 21], [45, 21], [45, 21], [45, 21]], [[36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [36, 16], [37, 17], [37, 17], [37, 17], [37, 17], [37, 17]], [[54, 24], [54, 24], [54, 24], [54, 24], [54, 24], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25], [55, 25]]]};
var QR_ALIGN = [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70]];
var QR_MAXV = 15;

/* ==========================================================================
   Earlsmere label designer — barcode + QR encoders (no dependencies)
   Requires the generated tables in tables.js:
     C128_CODES, C128_STOP, EAN_A, EAN_B, EAN_C, EAN_PARITY, EAN_EDGE,
     EAN_MIDDLE, QR_RS, QR_ALIGN, QR_MAXV
   ========================================================================== */

/* ---------------------------------------------------------------- Code 128 */
function code128Bits(raw) {
  var data = String(raw == null ? '' : raw);
  // Keep only the printable ASCII range Code 128 set B covers.
  var text = '';
  for (var i = 0; i < data.length; i++) {
    var c = data.charCodeAt(i);
    if (c >= 32 && c <= 126) text += data[i];
  }
  if (!text) return null;

  var allDigits = /^\d+$/.test(text);
  var useC = allDigits && text.length % 2 === 0 && text.length >= 4;
  var start = useC ? 105 : 104;
  var values = [];

  if (useC) {
    for (var j = 0; j < text.length; j += 2) values.push(parseInt(text.substr(j, 2), 10));
  } else {
    for (var k = 0; k < text.length; k++) values.push(text.charCodeAt(k) - 32);
  }

  var sum = start;
  for (var m = 0; m < values.length; m++) sum += (m + 1) * values[m];
  var check = sum % 103;

  var bits = C128_CODES[start];
  for (var n = 0; n < values.length; n++) bits += C128_CODES[values[n]];
  bits += C128_CODES[check];
  bits += C128_STOP;
  return { bits: bits, text: text, symbology: 'Code 128' };
}

/* ----------------------------------------------------------------- EAN-13 */
function ean13CheckDigit(twelve) {
  var sum = 0;
  for (var i = 0; i < 12; i++) sum += (i % 2 === 0 ? 1 : 3) * parseInt(twelve[i], 10);
  return (10 - (sum % 10)) % 10;
}

function ean13Bits(raw) {
  var digits = String(raw == null ? '' : raw).replace(/\D/g, '');
  if (digits.length === 12) digits += String(ean13CheckDigit(digits));
  if (digits.length !== 13) return null;
  if (ean13CheckDigit(digits.slice(0, 12)) !== parseInt(digits[12], 10)) {
    // Correct an invalid check digit rather than refusing to draw.
    digits = digits.slice(0, 12) + String(ean13CheckDigit(digits.slice(0, 12)));
  }

  var parity = EAN_PARITY[parseInt(digits[0], 10)];
  var bits = EAN_EDGE;
  for (var i = 1; i <= 6; i++) {
    var d = parseInt(digits[i], 10);
    bits += (parity[i - 1] === 'A' ? EAN_A : EAN_B)[d];
  }
  bits += EAN_MIDDLE;
  for (var j = 7; j <= 12; j++) bits += EAN_C[parseInt(digits[j], 10)];
  bits += EAN_EDGE;
  return { bits: bits, text: digits, symbology: 'EAN-13', human: digits };
}

function barcodeBits(symbology, value) {
  return symbology === 'ean13' ? ean13Bits(value) : code128Bits(value);
}

/* --------------------------------------------------------------- QR codes */
/* Galois field GF(256), primitive polynomial 0x11D. */
var QR_EXP = new Array(512);
var QR_LOG = new Array(256);
(function buildGaloisField() {
  var x = 1;
  for (var i = 0; i < 255; i++) {
    QR_EXP[i] = x;
    QR_LOG[x] = i;
    x <<= 1;
    if (x & 0x100) x ^= 0x11d;
  }
  for (var j = 255; j < 512; j++) QR_EXP[j] = QR_EXP[j - 255];
})();

function gfMul(a, b) {
  if (a === 0 || b === 0) return 0;
  return QR_EXP[QR_LOG[a] + QR_LOG[b]];
}

function rsGenerator(degree) {
  var poly = [1];
  for (var i = 0; i < degree; i++) {
    var next = new Array(poly.length + 1).fill(0);
    for (var j = 0; j < poly.length; j++) {
      next[j] ^= poly[j];                        // multiply by x
      next[j + 1] ^= gfMul(poly[j], QR_EXP[i]);  // multiply by the root
    }
    poly = next;
  }
  return poly;
}

function rsEncode(data, ecCount) {
  var gen = rsGenerator(ecCount);
  var res = new Array(ecCount).fill(0);
  for (var i = 0; i < data.length; i++) {
    var factor = data[i] ^ res[0];
    res.shift();
    res.push(0);
    if (factor !== 0) {
      for (var j = 0; j < ecCount; j++) res[j] ^= gfMul(gen[j + 1], factor);
    }
  }
  return res;
}

var QR_REMAINDER = [0, 7, 7, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 3, 3];
var QR_EC_BITS = { L: 1, M: 0, Q: 3, H: 2 };

function qrUtf8Bytes(str) {
  var out = [];
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i);
    if (c < 0x80) out.push(c);
    else if (c < 0x800) out.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f));
    else if (c >= 0xd800 && c <= 0xdbff && i + 1 < str.length) {
      var cp = 0x10000 + ((c - 0xd800) << 10) + (str.charCodeAt(++i) - 0xdc00);
      out.push(0xf0 | (cp >> 18), 0x80 | ((cp >> 12) & 0x3f), 0x80 | ((cp >> 6) & 0x3f), 0x80 | (cp & 0x3f));
    } else out.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
  }
  return out;
}

function qrBchFormat(value) {
  var d = value << 10;
  for (var i = 14; i >= 10; i--) if (d & (1 << i)) d ^= 0x537 << (i - 10);
  return ((value << 10) | d) ^ 0x5412;
}

function qrBchVersion(version) {
  var d = version << 12;
  for (var i = 17; i >= 12; i--) if (d & (1 << i)) d ^= 0x1f25 << (i - 12);
  return (version << 12) | d;
}

function qrCapacityBytes(version, level) {
  var blocks = QR_RS[level][version - 1];
  var total = 0;
  for (var i = 0; i < blocks.length; i++) total += blocks[i][1];
  var countBits = version < 10 ? 8 : 16;
  var overhead = Math.ceil((4 + countBits) / 8);
  return total - overhead;
}

/** Returns { size, modules: [[bool,...],...], version, level } or null. */
function qrEncode(text, level) {
  var lvl = QR_RS[level] ? level : 'M';
  var bytes = qrUtf8Bytes(String(text == null ? '' : text));
  if (!bytes.length) return null;

  var version = 0;
  for (var v = 1; v <= QR_MAXV; v++) {
    if (bytes.length <= qrCapacityBytes(v, lvl)) { version = v; break; }
  }
  if (!version) return null;

  /* --- bit stream --- */
  var bits = [];
  function push(value, length) {
    for (var i = length - 1; i >= 0; i--) bits.push((value >> i) & 1);
  }
  push(4, 4);                                   // byte mode
  push(bytes.length, version < 10 ? 8 : 16);    // character count
  for (var b = 0; b < bytes.length; b++) push(bytes[b], 8);

  var blocks = QR_RS[lvl][version - 1];
  var dataBytes = 0, totalBytes = 0;
  for (var i0 = 0; i0 < blocks.length; i0++) { totalBytes += blocks[i0][0]; dataBytes += blocks[i0][1]; }

  var capacityBits = dataBytes * 8;
  for (var t = 0; t < 4 && bits.length < capacityBits; t++) bits.push(0);
  while (bits.length % 8 !== 0) bits.push(0);
  var pads = [0xec, 0x11], p = 0;
  while (bits.length < capacityBits) { push(pads[p++ % 2], 8); }

  var codewords = [];
  for (var c = 0; c < bits.length; c += 8) {
    var byte = 0;
    for (var k = 0; k < 8; k++) byte = (byte << 1) | bits[c + k];
    codewords.push(byte);
  }

  /* --- split into blocks, add error correction, interleave --- */
  var dataBlocks = [], ecBlocks = [], offset = 0;
  for (var bi = 0; bi < blocks.length; bi++) {
    var dc = blocks[bi][1];
    var ecCount = blocks[bi][0] - dc;
    var chunk = codewords.slice(offset, offset + dc);
    offset += dc;
    dataBlocks.push(chunk);
    ecBlocks.push(rsEncode(chunk, ecCount));
  }
  var interleaved = [];
  var maxData = Math.max.apply(null, dataBlocks.map(function (x) { return x.length; }));
  for (var d1 = 0; d1 < maxData; d1++) {
    for (var d2 = 0; d2 < dataBlocks.length; d2++) if (d1 < dataBlocks[d2].length) interleaved.push(dataBlocks[d2][d1]);
  }
  var maxEc = Math.max.apply(null, ecBlocks.map(function (x) { return x.length; }));
  for (var e1 = 0; e1 < maxEc; e1++) {
    for (var e2 = 0; e2 < ecBlocks.length; e2++) if (e1 < ecBlocks[e2].length) interleaved.push(ecBlocks[e2][e1]);
  }

  var finalBits = [];
  for (var f = 0; f < interleaved.length; f++) {
    for (var fb = 7; fb >= 0; fb--) finalBits.push((interleaved[f] >> fb) & 1);
  }
  for (var r = 0; r < QR_REMAINDER[version - 1]; r++) finalBits.push(0);

  /* --- module matrix --- */
  var size = version * 4 + 17;
  var mods = [], reserved = [];
  for (var y = 0; y < size; y++) {
    mods.push(new Array(size).fill(0));
    reserved.push(new Array(size).fill(false));
  }

  function setFn(x, y, value) {
    if (x < 0 || y < 0 || x >= size || y >= size) return;
    mods[y][x] = value ? 1 : 0;
    reserved[y][x] = true;
  }

  function placeFinder(cx, cy) {
    for (var dy = -1; dy <= 7; dy++) {
      for (var dx = -1; dx <= 7; dx++) {
        var xx = cx + dx, yy = cy + dy;
        if (xx < 0 || yy < 0 || xx >= size || yy >= size) continue;
        var inRing = (dx >= 0 && dx <= 6 && (dy === 0 || dy === 6)) ||
                     (dy >= 0 && dy <= 6 && (dx === 0 || dx === 6));
        var inCore = dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4;
        setFn(xx, yy, inRing || inCore);
      }
    }
  }
  placeFinder(0, 0);
  placeFinder(size - 7, 0);
  placeFinder(0, size - 7);

  for (var tp = 8; tp < size - 8; tp++) {
    setFn(tp, 6, tp % 2 === 0);
    setFn(6, tp, tp % 2 === 0);
  }

  var aligns = QR_ALIGN[version - 1];
  for (var a1 = 0; a1 < aligns.length; a1++) {
    for (var a2 = 0; a2 < aligns.length; a2++) {
      var ax = aligns[a1], ay = aligns[a2];
      if ((ax <= 8 && ay <= 8) || (ax <= 8 && ay >= size - 9) || (ax >= size - 9 && ay <= 8)) continue;
      for (var my = -2; my <= 2; my++) {
        for (var mx = -2; mx <= 2; mx++) {
          var ring = Math.max(Math.abs(mx), Math.abs(my));
          setFn(ax + mx, ay + my, ring !== 1);
        }
      }
    }
  }

  setFn(8, size - 8, true); // dark module

  // reserve format information areas
  for (var fi = 0; fi < 9; fi++) {
    if (!reserved[fi][8]) setFn(8, fi, false);
    if (!reserved[8][fi]) setFn(fi, 8, false);
  }
  for (var fj = 0; fj < 8; fj++) {
    if (!reserved[8][size - 1 - fj]) setFn(size - 1 - fj, 8, false);
    if (!reserved[size - 1 - fj][8]) setFn(8, size - 1 - fj, false);
  }

  // reserve version information areas (version 7+)
  if (version >= 7) {
    for (var vi = 0; vi < 18; vi++) {
      var vr = Math.floor(vi / 3), vc = vi % 3;
      setFn(vr, size - 11 + vc, false);
      setFn(size - 11 + vc, vr, false);
    }
  }

  /* --- zig-zag data placement --- */
  var bitIndex = 0, upward = true;
  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col = 5; // skip the vertical timing column
    for (var row = 0; row < size; row++) {
      var yPos = upward ? size - 1 - row : row;
      for (var q = 0; q < 2; q++) {
        var xPos = col - q;
        if (reserved[yPos][xPos]) continue;
        mods[yPos][xPos] = bitIndex < finalBits.length ? finalBits[bitIndex] : 0;
        bitIndex++;
      }
    }
    upward = !upward;
  }

  /* --- masking --- */
  function maskFn(m, x, y) {
    switch (m) {
      case 0: return (x + y) % 2 === 0;
      case 1: return y % 2 === 0;
      case 2: return x % 3 === 0;
      case 3: return (x + y) % 3 === 0;
      case 4: return (Math.floor(y / 2) + Math.floor(x / 3)) % 2 === 0;
      case 5: return ((x * y) % 2) + ((x * y) % 3) === 0;
      case 6: return (((x * y) % 2) + ((x * y) % 3)) % 2 === 0;
      default: return (((x + y) % 2) + ((x * y) % 3)) % 2 === 0;
    }
  }

  function penalty(grid) {
    var score = 0, i, j, run, dark = 0;
    // rule 1: runs of five or more
    for (i = 0; i < size; i++) {
      run = 1;
      for (j = 1; j < size; j++) {
        if (grid[i][j] === grid[i][j - 1]) { run++; } else { if (run >= 5) score += run - 2; run = 1; }
      }
      if (run >= 5) score += run - 2;
      run = 1;
      for (j = 1; j < size; j++) {
        if (grid[j][i] === grid[j - 1][i]) { run++; } else { if (run >= 5) score += run - 2; run = 1; }
      }
      if (run >= 5) score += run - 2;
    }
    // rule 2: 2x2 blocks
    for (i = 0; i < size - 1; i++) {
      for (j = 0; j < size - 1; j++) {
        var v = grid[i][j];
        if (v === grid[i][j + 1] && v === grid[i + 1][j] && v === grid[i + 1][j + 1]) score += 3;
      }
    }
    // rule 3: finder-like patterns
    var pat1 = [1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0];
    var pat2 = [0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1];
    function matches(get, at, pat) {
      for (var z = 0; z < 11; z++) if (get(at + z) !== pat[z]) return false;
      return true;
    }
    for (i = 0; i < size; i++) {
      for (j = 0; j <= size - 11; j++) {
        var rowGet = (function (rr) { return function (cc) { return grid[rr][cc]; }; })(i);
        var colGet = (function (cc) { return function (rr) { return grid[rr][cc]; }; })(i);
        if (matches(rowGet, j, pat1) || matches(rowGet, j, pat2)) score += 40;
        if (matches(colGet, j, pat1) || matches(colGet, j, pat2)) score += 40;
      }
    }
    // rule 4: dark/light balance
    for (i = 0; i < size; i++) for (j = 0; j < size; j++) if (grid[i][j]) dark++;
    var pct = (dark * 100) / (size * size);
    score += Math.floor(Math.abs(pct - 50) / 5) * 10;
    return score;
  }

  var best = null, bestScore = Infinity, bestMask = 0;
  for (var mk = 0; mk < 8; mk++) {
    var grid = [];
    for (var gy = 0; gy < size; gy++) {
      grid.push(mods[gy].slice());
      for (var gx = 0; gx < size; gx++) {
        if (!reserved[gy][gx] && maskFn(mk, gx, gy)) grid[gy][gx] ^= 1;
      }
    }
    // write format information for this mask before scoring
    var fmt = qrBchFormat((QR_EC_BITS[lvl] << 3) | mk);
    for (var fb2 = 0; fb2 < 15; fb2++) {
      var bit = (fmt >> fb2) & 1;
      if (fb2 < 6) grid[fb2][8] = bit;
      else if (fb2 === 6) grid[7][8] = bit;
      else if (fb2 === 7) grid[8][8] = bit;
      else if (fb2 === 8) grid[8][7] = bit;
      else grid[8][14 - fb2] = bit;

      if (fb2 < 8) grid[8][size - 1 - fb2] = bit;
      else grid[size - 15 + fb2][8] = bit;
    }
    grid[size - 8][8] = 1; // dark module

    if (version >= 7) {
      var vinfo = qrBchVersion(version);
      for (var vb = 0; vb < 18; vb++) {
        var vbit = (vinfo >> vb) & 1;
        grid[Math.floor(vb / 3)][size - 11 + (vb % 3)] = vbit;
        grid[size - 11 + (vb % 3)][Math.floor(vb / 3)] = vbit;
      }
    }

    var sc = penalty(grid);
    if (sc < bestScore) { bestScore = sc; best = grid; bestMask = mk; }
  }

  return { size: size, modules: best, version: version, level: lvl, mask: bestMask };
}



window.__ELD_CODES = { barcodeBits: barcodeBits, qrEncode: qrEncode, ean13CheckDigit: ean13CheckDigit };
})();
var barcodeBits = window.__ELD_CODES.barcodeBits,
    qrEncode = window.__ELD_CODES.qrEncode,
    ean13CheckDigit = window.__ELD_CODES.ean13CheckDigit;
/* Earlsmere label designer — symbol library.
 *
 * Every symbol is plain vector geometry drawn on a 100 × 100 grid, so it stays
 * sharp at any size and travels in a design code as nothing more than its id.
 *
 *   id      what the design code stores
 *   name    what the customer reads
 *   cat     which tab it sits under
 *   locked  true  = safety colours are fixed and the colour control is hidden
 *           false = the customer may recolour it
 *   paths   drawn in order. `f` fills, `s` strokes at width `sw`.
 *           "@" in either means "use the element's colour".
 *
 * The frames and generic shapes below are drawn from scratch — simple geometry,
 * nothing lifted from anywhere. Earlsmere's own pictograms drop in alongside them
 * via tools/svg2symbols.py, which emits entries in exactly this shape.
 */
(function () {
  var YELLOW = '#F9C300', RED = '#C8102E', BLUE = '#0057B8',
      GREEN = '#00843D', BLACK = '#1a1a1a', WHITE = '#ffffff';

  window.__ELD_SYMBOLS = [

    /* ---------------------------------------------------------- frames */
    { id: 'frame-warning', name: 'Warning triangle', cat: 'Frames', locked: true, paths: [
      { d: 'M50 5 L97 88 L3 88 Z', f: BLACK },
      { d: 'M50 20 L84 80 L16 80 Z', f: YELLOW }
    ] },

    { id: 'frame-warning-bang', name: 'General warning', cat: 'Frames', locked: true, paths: [
      { d: 'M50 5 L97 88 L3 88 Z', f: BLACK },
      { d: 'M50 20 L84 80 L16 80 Z', f: YELLOW },
      { d: 'M46 38 h8 v22 h-8 Z', f: BLACK },
      { d: 'M50 66 m-4.5 0 a4.5 4.5 0 1 0 9 0 a4.5 4.5 0 1 0 -9 0', f: BLACK }
    ] },

    { id: 'frame-prohibition', name: 'Prohibition circle', cat: 'Frames', locked: true, paths: [
      { d: 'M50 50 m-46 0 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0', f: RED },
      { d: 'M50 50 m-36 0 a36 36 0 1 0 72 0 a36 36 0 1 0 -72 0', f: WHITE },
      { d: 'M23.5 70.8 L70.8 23.5 L76.5 29.2 L29.2 76.5 Z', f: RED }
    ] },

    { id: 'frame-mandatory', name: 'Mandatory disc', cat: 'Frames', locked: true, paths: [
      { d: 'M50 50 m-46 0 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0', f: BLUE }
    ] },

    { id: 'frame-safe', name: 'Safe condition', cat: 'Frames', locked: true, paths: [
      { d: 'M10 10 h80 a6 6 0 0 1 6 6 v68 a6 6 0 0 1 -6 6 h-80 a6 6 0 0 1 -6 -6 v-68 a6 6 0 0 1 6 -6 Z', f: GREEN }
    ] },

    { id: 'frame-fire', name: 'Fire equipment', cat: 'Frames', locked: true, paths: [
      { d: 'M10 10 h80 a6 6 0 0 1 6 6 v68 a6 6 0 0 1 -6 6 h-80 a6 6 0 0 1 -6 -6 v-68 a6 6 0 0 1 6 -6 Z', f: RED }
    ] },

    /* ---------------------------------------------------------- marks */
    { id: 'mark-tick', name: 'Tick', cat: 'Marks', locked: false, paths: [
      { d: 'M18 52 L40 74 L84 24', s: '@', sw: 13 }
    ] },

    { id: 'mark-cross', name: 'Cross', cat: 'Marks', locked: false, paths: [
      { d: 'M22 22 L78 78 M78 22 L22 78', s: '@', sw: 13 }
    ] },

    { id: 'mark-bang', name: 'Exclamation', cat: 'Marks', locked: false, paths: [
      { d: 'M43 12 h14 v50 h-14 Z', f: '@' },
      { d: 'M50 79 m-8 0 a8 8 0 1 0 16 0 a8 8 0 1 0 -16 0', f: '@' }
    ] },

    { id: 'mark-first-aid', name: 'First aid cross', cat: 'Marks', locked: false, paths: [
      { d: 'M38 10 h24 v28 h28 v24 h-28 v28 h-24 v-28 h-28 v-24 h28 Z', f: '@' }
    ] },

    /* ---------------------------------------------------------- arrows */
    { id: 'arrow-up', name: 'Arrow up', cat: 'Arrows', locked: false, paths: [
      { d: 'M50 8 L86 46 H64 V92 H36 V46 H14 Z', f: '@' }
    ] },

    { id: 'arrow-right', name: 'Arrow right', cat: 'Arrows', locked: false, paths: [
      { d: 'M92 50 L54 86 V64 H8 V36 H54 V14 Z', f: '@' }
    ] },

    { id: 'arrow-chevron', name: 'Chevron', cat: 'Arrows', locked: false, paths: [
      { d: 'M32 14 L68 50 L32 86', s: '@', sw: 14 }
    ] },

    /* ---------------------------------------------------------- shapes */
    { id: 'shape-diamond', name: 'Diamond', cat: 'Shapes', locked: false, paths: [
      { d: 'M50 6 L94 50 L50 94 L6 50 Z', s: '@', sw: 8 }
    ] },

    { id: 'shape-circle', name: 'Circle', cat: 'Shapes', locked: false, paths: [
      { d: 'M50 50 m-44 0 a44 44 0 1 0 88 0 a44 44 0 1 0 -88 0', s: '@', sw: 8 }
    ] },

    { id: 'shape-circle-solid', name: 'Filled circle', cat: 'Shapes', locked: false, paths: [
      { d: 'M50 50 m-46 0 a46 46 0 1 0 92 0 a46 46 0 1 0 -92 0', f: '@' }
    ] }
  ];
})();

/* ==========================================================================
   Earlsmere "Design Your Own Label"
   Full-colour digital labels on paper, polypropylene or polyester, printed
   3-up or 1-up on a 220 mm web. Vanilla JS, no dependencies, scoped to .eld.
   Depends on codes.js for barcodeBits() and qrEncode().
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.ELD_CONFIG || {};
  var SYMBOLS = window.__ELD_SYMBOLS || [];
  function symDef(id) {
    for (var i = 0; i < SYMBOLS.length; i++) if (SYMBOLS[i].id === id) return SYMBOLS[i];
    return null;
  }
  var IS_SHOPIFY = !!(window.Shopify && window.Shopify.routes) || CFG.forceShopify === true;

  /* ------------------------------------------------------- press constants */
  var WEB_MM = Number(CFG.webWidth) || 220;    // backing paper width
  var MAX_3UP = Number(CFG.maxWidth3) || 71;   // widest label that still runs 3 across
  var MAX_1UP = Number(CFG.maxWidth1) || 216;  // widest label we can run at all
  var GAP_MM = Number(CFG.gapMm) || 3;         // gap between labels
  var MAX_H = Number(CFG.maxHeight) || 300;    // the web has no length limit; this is a sanity cap

  var SIZES_3UP = [[25, 25], [30, 30], [40, 40], [50, 50], [35, 25], [45, 25], [50, 30], [50, 75], [40, 60], [30, 60]];
  var SIZES_1UP = [[60, 40], [76, 51], [90, 60], [100, 70], [100, 100], [100, 150], [105, 148], [120, 80], [148, 105], [150, 100]];
  var QTY_CHIPS = [250, 500, 1000, 2500, 5000, 10000];

  var LABELS = {
    /* 'unlaminated' is kept as the key for no lamination so design codes saved
       before matt and gloss were split still load. Legacy 'laminated' maps to
       gloss on the way in — see loadCode. */
    finish: { unlaminated: 'Unlaminated', matt: 'Matt lamination', gloss: 'Gloss lamination' },
    material: {
      hgloss: 'High gloss paper',
      sgloss: 'Semi-gloss paper',
      pp: 'Polypropylene',
      pet: 'Polyester'
    },
    adhesive: { perm: 'Permanent', xperm: 'Extra permanent', peel: 'Peelable' },
    shape: { rect: 'Rectangle', square: 'Square', circle: 'Circle' }
  };
  function isPaper() { return state.material === 'hgloss' || state.material === 'sgloss'; }
  function isLaminated() { return state.finish !== 'unlaminated'; }

  var SAFE_MM = 2;          // keep artwork this far inside the die line
  var PROOF_DPI = 300;
  var SENT_KEY = 'eld:pending-enquiry';   // survives the /contact round trip

  /* ------------------------------------------------------------------ state */
  var uid = 0;
  var state = {
    w: 50, h: 75, shape: 'rect', radius: 3,
    material: 'pp', adhesive: 'perm', finish: 'unlaminated',
    env: { outdoor: false, cold: false, chem: false, abrasion: false },
    bg: '#ffffff', elements: [],
    quantity: 1000,
    sample: false, repeat: false, deadline: '',
    name: '', company: '', email: '', phone: '', notes: ''
  };
  var selectedId = null;
  var zoom = 0;            // 0 = fit
  var showGuides = true;
  var root, canvas, ctx;

  /* ----------------------------------------------------------------- helpers */
  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function num(v, min, max, fallback) {
    var n = parseFloat(v);
    if (!isFinite(n)) return fallback;
    return Math.min(max, Math.max(min, n));
  }
  function round1(n) { return parseFloat(Number(n).toFixed(1)); }
  function fmtMm(n) { return String(parseFloat(Number(n).toFixed(1))); }
  function fmtInt(n) { return Number(n).toLocaleString('en-GB'); }

  /* ------------------------------------------------------------- geometry */
  function labelW() { return state.w; }
  function labelH() { return state.shape === 'rect' ? state.h : state.w; }
  function isRound() { return state.shape === 'circle'; }

  /** 3 across the web if it fits, otherwise 1. */
  function acrossCount() { return labelW() <= MAX_3UP ? 3 : 1; }

  function runInfo() {
    var across = acrossCount();
    var qty = Math.max(1, Math.round(state.quantity || 1));
    var rows = Math.ceil(qty / across);
    var rounded = rows * across;
    var lengthMm = rows * (labelH() + GAP_MM) + GAP_MM;
    return { across: across, rows: rows, rounded: rounded, lengthM: lengthMm / 1000 };
  }

  function textLines(e, pxPerMm, c) {
    c.font = fontString(e, pxPerMm);
    var maxPx = (e.w || labelW()) * pxPerMm;
    var out = [];
    String(e.text || '').split('\n').forEach(function (para) {
      var words = para.split(/\s+/).filter(Boolean);
      if (!words.length) { out.push(''); return; }
      var line = words[0];
      for (var i = 1; i < words.length; i++) {
        if (c.measureText(line + ' ' + words[i]).width <= maxPx) line += ' ' + words[i];
        else { out.push(line); line = words[i]; }
      }
      out.push(line);
    });
    return out;
  }

  function fontString(e, pxPerMm) {
    var style = e.italic ? 'italic ' : '';
    return style + (e.weight || 600) + ' ' + (e.size * pxPerMm) + 'px ' + (CFG.canvasFont || '"Inter", Helvetica, Arial, sans-serif');
  }

  function bounds(e) {
    switch (e.type) {
      case 'text':
      case 'serial': {
        var pxPerMm = 4;
        ctx.save();
        var lines = e.type === 'serial' ? [serialSample(e)] : textLines(e, pxPerMm, ctx);
        ctx.font = fontString(e, pxPerMm);
        var wMax = 0;
        lines.forEach(function (l) { wMax = Math.max(wMax, ctx.measureText(l).width / pxPerMm); });
        ctx.restore();
        var lh = e.size * (e.lineHeight || 1.22);
        return { x: e.x, y: e.y, w: Math.max(wMax, 1), h: Math.max(lines.length * lh, e.size) };
      }
      case 'qr': return { x: e.x, y: e.y, w: e.size, h: e.size };
      case 'line': return { x: e.x, y: e.y - (e.thickness / 2), w: e.w, h: Math.max(e.thickness, 1) };
      default: return { x: e.x, y: e.y, w: e.w, h: e.h };
    }
  }

  function serialSample(e) {
    var n = String(e.start == null ? 1 : e.start);
    while (n.length < (e.digits || 5)) n = '0' + n;
    return (e.prefix || '') + n + (e.suffix || '');
  }

  /* ------------------------------------------------------------- rendering */
  function roundRectPath(c, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, Math.min(w, h) / 2));
    c.beginPath();
    c.moveTo(x + r, y);
    c.lineTo(x + w - r, y);
    c.arcTo(x + w, y, x + w, y + r, r);
    c.lineTo(x + w, y + h - r);
    c.arcTo(x + w, y + h, x + w - r, y + h, r);
    c.lineTo(x + r, y + h);
    c.arcTo(x, y + h, x, y + h - r, r);
    c.lineTo(x, y + r);
    c.arcTo(x, y, x + r, y, r);
    c.closePath();
  }

  function labelPath(c, pxPerMm) {
    var w = labelW() * pxPerMm, h = labelH() * pxPerMm;
    if (isRound()) {
      c.beginPath();
      c.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
      c.closePath();
    } else {
      roundRectPath(c, 0, 0, w, h, state.radius * pxPerMm);
    }
  }

  function drawBarcode(c, e, pxPerMm) {
    var res = barcodeBits(e.symbology, e.value);
    var x = e.x * pxPerMm, y = e.y * pxPerMm, w = e.w * pxPerMm, h = e.h * pxPerMm;
    if (!res) {
      c.save();
      c.fillStyle = 'rgba(180,105,14,.12)';
      c.fillRect(x, y, w, h);
      c.strokeStyle = '#b4690e'; c.lineWidth = Math.max(1, pxPerMm * 0.2);
      c.setLineDash([pxPerMm * 1.2, pxPerMm * 1.2]);
      c.strokeRect(x, y, w, h);
      c.setLineDash([]);
      c.fillStyle = '#b4690e';
      c.font = (Math.max(6, h * 0.22)) + 'px ' + (CFG.canvasFont || 'Helvetica, Arial, sans-serif');
      c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText('Barcode value not valid', x + w / 2, y + h / 2);
      c.restore();
      return;
    }
    var bits = res.bits;
    var textH = e.showText ? h * 0.2 : 0;
    var barsH = h - textH;
    var unit = w / bits.length;
    c.save();
    c.fillStyle = e.colour || '#000000';
    for (var i = 0; i < bits.length; i++) {
      if (bits[i] === '1') c.fillRect(x + i * unit, y, Math.ceil(unit), barsH);
    }
    if (e.showText) {
      c.fillStyle = e.colour || '#000000';
      c.font = '600 ' + (textH * 0.86) + 'px ' + (CFG.canvasFont || 'Helvetica, Arial, sans-serif');
      c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      c.fillText(res.human || res.text, x + w / 2, y + h - textH * 0.12);
    }
    c.restore();
  }

  function drawQr(c, e, pxPerMm) {
    var res = qrEncode(e.value, e.ec || 'M');
    var x = e.x * pxPerMm, y = e.y * pxPerMm, size = e.size * pxPerMm;
    c.save();
    if (!res) {
      c.strokeStyle = '#b4690e'; c.lineWidth = Math.max(1, pxPerMm * 0.2);
      c.setLineDash([pxPerMm * 1.2, pxPerMm * 1.2]);
      c.strokeRect(x, y, size, size);
      c.restore();
      return;
    }
    var quiet = 4;
    var n = res.size + quiet * 2;
    var m = size / n;
    c.fillStyle = '#ffffff';
    c.fillRect(x, y, size, size);
    c.fillStyle = e.colour || '#000000';
    for (var yy = 0; yy < res.size; yy++) {
      for (var xx = 0; xx < res.size; xx++) {
        if (res.modules[yy][xx]) c.fillRect(x + (xx + quiet) * m, y + (yy + quiet) * m, Math.ceil(m), Math.ceil(m));
      }
    }
    c.restore();
  }

  function drawElement(c, e, pxPerMm) {
    switch (e.type) {
      case 'symbol': {
        var def = symDef(e.sym);
        if (!def) break;                       // unknown id: draw nothing rather than guess
        c.save();
        c.translate(e.x * pxPerMm, e.y * pxPerMm);
        c.scale((e.w * pxPerMm) / 100, (e.h * pxPerMm) / 100);
        c.lineJoin = 'round';
        c.lineCap = 'round';
        (def.paths || []).forEach(function (p) {
          var path = new Path2D(p.d);
          if (p.f) {
            c.fillStyle = p.f === '@' ? (e.colour || '#000000') : p.f;
            c.fill(path, p.fr === 'evenodd' ? 'evenodd' : 'nonzero');
          }
          if (p.s) {
            c.strokeStyle = p.s === '@' ? (e.colour || '#000000') : p.s;
            c.lineWidth = (p.sw == null) ? 6 : p.sw;   // 0 is a real width, not "unset"
            c.stroke(path);
          }
        });
        c.restore();
        break;
      }
      case 'box': {
        c.save();
        roundRectPath(c, e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm, (e.radius || 0) * pxPerMm);
        if (e.fill && e.fill !== 'none') { c.fillStyle = e.fill; c.fill(); }
        if (e.strokeW > 0) { c.strokeStyle = e.stroke || '#000'; c.lineWidth = e.strokeW * pxPerMm; c.stroke(); }
        c.restore();
        break;
      }
      case 'line': {
        c.save();
        c.strokeStyle = e.colour || '#000';
        c.lineWidth = Math.max(0.05, e.thickness) * pxPerMm;
        c.lineCap = 'butt';
        c.beginPath();
        c.moveTo(e.x * pxPerMm, e.y * pxPerMm);
        c.lineTo((e.x + e.w) * pxPerMm, e.y * pxPerMm);
        c.stroke();
        c.restore();
        break;
      }
      case 'image': {
        if (e._img && e._img.complete && e._img.naturalWidth) {
          c.drawImage(e._img, e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm);
        } else {
          c.save();
          c.fillStyle = 'rgba(12,21,25,.06)';
          c.fillRect(e.x * pxPerMm, e.y * pxPerMm, e.w * pxPerMm, e.h * pxPerMm);
          c.restore();
        }
        break;
      }
      case 'barcode': drawBarcode(c, e, pxPerMm); break;
      case 'qr': drawQr(c, e, pxPerMm); break;
      case 'text':
      case 'serial': {
        c.save();
        c.fillStyle = e.colour || '#000';
        c.font = fontString(e, pxPerMm);
        c.textBaseline = 'top';
        var lines = e.type === 'serial' ? [serialSample(e)] : textLines(e, pxPerMm, c);
        var lh = e.size * (e.lineHeight || 1.22) * pxPerMm;
        var b = bounds(e);
        lines.forEach(function (line, i) {
          var lx = e.x * pxPerMm;
          if (e.align === 'center') { c.textAlign = 'center'; lx = (e.x + b.w / 2) * pxPerMm; }
          else if (e.align === 'right') { c.textAlign = 'right'; lx = (e.x + b.w) * pxPerMm; }
          else c.textAlign = 'left';
          c.fillText(line, lx, e.y * pxPerMm + i * lh);
        });
        c.restore();
        break;
      }
    }
  }

  function renderTo(c, pxPerMm, opts) {
    opts = opts || {};
    var w = labelW() * pxPerMm, h = labelH() * pxPerMm;
    c.clearRect(0, 0, w, h);

    c.save();
    labelPath(c, pxPerMm);
    c.fillStyle = state.bg || '#ffffff';
    c.fill();
    c.clip();
    state.elements.forEach(function (e) { drawElement(c, e, pxPerMm); });
    c.restore();

    c.save();
    labelPath(c, pxPerMm);
    c.strokeStyle = opts.guides ? 'rgba(12,21,25,.55)' : 'rgba(12,21,25,.22)';
    c.lineWidth = Math.max(1, pxPerMm * 0.12);
    c.stroke();
    c.restore();

    if (opts.guides) {
      c.save();
      c.setLineDash([pxPerMm * 1.6, pxPerMm * 1.4]);
      c.strokeStyle = 'rgba(0,160,223,.75)';
      c.lineWidth = Math.max(1, pxPerMm * 0.1);
      var s = SAFE_MM * pxPerMm;
      if (isRound()) {
        c.beginPath();
        c.ellipse(w / 2, h / 2, Math.max(1, w / 2 - s), Math.max(1, h / 2 - s), 0, 0, Math.PI * 2);
        c.stroke();
      } else {
        roundRectPath(c, s, s, Math.max(1, w - s * 2), Math.max(1, h - s * 2),
          Math.max(0, state.radius * pxPerMm - s));
        c.stroke();
      }
      c.restore();
    }

    if (opts.selection && selectedId) {
      var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
      if (sel) {
        var b = bounds(sel);
        c.save();
        c.strokeStyle = '#00A0DF';
        c.lineWidth = 1.5;
        c.setLineDash([4, 3]);
        c.strokeRect(b.x * pxPerMm - 2, b.y * pxPerMm - 2, b.w * pxPerMm + 4, b.h * pxPerMm + 4);
        c.setLineDash([]);
        c.fillStyle = '#00A0DF';
        var hx = (b.x + b.w) * pxPerMm + 2, hy = (b.y + b.h) * pxPerMm + 2;
        c.fillRect(hx - 5, hy - 5, 10, 10);
        c.restore();
      }
    }
  }

  function fitScale() {
    var wrap = $('[data-eld-canvaswrap]');
    var availW = Math.max(160, wrap.clientWidth - 52);
    var availH = Math.max(300, Math.min(600, (window.innerHeight || 900) * 0.62));
    return Math.min(availW / labelW(), availH / labelH());
  }

  function currentScale() { return zoom > 0 ? zoom : fitScale(); }

  function draw() {
    var pxPerMm = currentScale();
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var cssW = Math.max(1, Math.round(labelW() * pxPerMm));
    var cssH = Math.max(1, Math.round(labelH() * pxPerMm));
    canvas.style.width = cssW + 'px';
    canvas.style.height = cssH + 'px';
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    renderTo(ctx, pxPerMm, { guides: showGuides, selection: true });
    $('[data-eld-zoomval]').textContent = zoom > 0 ? Math.round(pxPerMm / (96 / 25.4) * 100) + '%' : 'Fit';
    var dims = isRound() ? ('&empty;&thinsp;' + fmtMm(labelW())) : (fmtMm(labelW()) + ' &times; ' + fmtMm(labelH()));
    $('[data-eld-readout]').innerHTML = dims + '&thinsp;mm <span>' +
      esc(LABELS.shape[state.shape]) + ' &middot; ' + acrossCount() + ' across</span>';
  }

  /* --------------------------------------------------------- layout diagram */
  function renderLayout() {
    var host = $('[data-eld-layout]');
    if (!host) return;
    var across = acrossCount();
    var lw = labelW(), lh = labelH();
    var used = across * lw + (across - 1) * GAP_MM;
    var left = (WEB_MM - used) / 2;
    var rows = 2;
    var vh = rows * lh + (rows + 1) * GAP_MM;

    var shapes = '';
    for (var r = 0; r < rows; r++) {
      for (var i = 0; i < across; i++) {
        var x = left + i * (lw + GAP_MM);
        var y = GAP_MM + r * (lh + GAP_MM);
        if (isRound()) {
          shapes += '<ellipse cx="' + (x + lw / 2) + '" cy="' + (y + lh / 2) + '" rx="' + (lw / 2) + '" ry="' + (lh / 2) +
            '" fill="#fff" stroke="#00A0DF" stroke-width="1"/>';
        } else {
          shapes += '<rect x="' + x + '" y="' + y + '" width="' + lw + '" height="' + lh +
            '" rx="' + Math.min(state.radius, Math.min(lw, lh) / 2) + '" fill="#fff" stroke="#00A0DF" stroke-width="1"/>';
        }
      }
    }

    var over = lw > MAX_1UP;
    host.innerHTML =
      '<div class="eld__note' + (over ? ' eld__note--warn' : '') + '" style="display:flex;gap:14px;align-items:center">' +
      '<svg viewBox="0 0 ' + WEB_MM + ' ' + vh + '" style="width:100px;flex:none" aria-hidden="true">' +
      '<rect x="0" y="0" width="' + WEB_MM + '" height="' + vh + '" fill="#dbe6ec"/>' + shapes +
      '</svg>' +
      '<div>' + (over
        ? '<strong>Too wide.</strong> The widest we can print is ' + MAX_1UP + '&thinsp;mm across.'
        : '<strong>' + across + ' across</strong> the ' + WEB_MM + '&thinsp;mm web' +
          (across === 3
            ? '. Three up is the most economical way to run a label this size.'
            : '. Anything over ' + MAX_3UP + '&thinsp;mm wide runs one up.')) +
      '</div></div>';
  }

  /* ------------------------------------------------------- element factory */
  function makeElement(type, extra) {
    var W = labelW(), H = labelH();
    var base = { id: 'e' + (++uid), type: type };
    var defaults = {
      text: { text: 'Your text here', x: W * 0.1, y: H * 0.1, w: W * 0.8, size: Math.max(2.2, Math.min(W, H) * 0.1), weight: 700, colour: '#000000', align: 'left', lineHeight: 1.22 },
      serial: { prefix: 'EM-', start: 1, digits: 5, suffix: '', x: W * 0.1, y: H * 0.45, size: Math.max(2, Math.min(W, H) * 0.085), weight: 700, colour: '#000000', align: 'left', lineHeight: 1.22 },
      image: { src: '', x: W * 0.1, y: H * 0.1, w: W * 0.4, h: W * 0.4 },
      barcode: { symbology: 'code128', value: 'EARLSMERE-0001', x: W * 0.1, y: H * 0.6, w: W * 0.8, h: Math.max(7, H * 0.18), showText: true, colour: '#000000' },
      qr: { value: 'https://earlsmere.co.uk', ec: 'M', x: W * 0.5, y: H * 0.5, size: Math.min(W, H) * 0.32, colour: '#000000' },
      box: { x: W * 0.08, y: H * 0.08, w: W * 0.84, h: H * 0.3, fill: 'none', stroke: '#000000', strokeW: 0.4, radius: 1 },
      line: { x: W * 0.1, y: H * 0.5, w: W * 0.8, thickness: 0.4, colour: '#000000' },
      symbol: { sym: '', x: W * 0.1, y: H * 0.1, w: Math.min(W, H) * 0.35, h: Math.min(W, H) * 0.35, colour: '#000000' }
    }[type];
    var e = Object.assign(base, defaults, extra || {});
    ['x', 'y', 'w', 'h', 'size', 'radius', 'thickness', 'strokeW'].forEach(function (k) {
      if (typeof e[k] === 'number') e[k] = round1(e[k]);
    });
    if (!extra || (extra.x == null && extra.y == null)) {
      var step = Math.min(6, Math.max(1.5, Math.min(W, H) * 0.05));
      var n = state.elements.length % 6;
      e.x = round1(Math.min(e.x + n * step, Math.max(0, W - 6)));
      e.y = round1(Math.min(e.y + n * step, Math.max(0, H - 6)));
    }
    state.elements.push(e);
    selectedId = e.id;
    return e;
  }

  function elementName(e) {
    switch (e.type) {
      case 'text': return (String(e.text || '').split('\n')[0] || 'Text').slice(0, 34);
      case 'serial': return serialSample(e);
      case 'barcode': return (e.symbology === 'ean13' ? 'EAN-13 ' : 'Code 128 ') + (e.value || '');
      case 'qr': return 'QR: ' + String(e.value || '').slice(0, 28);
      case 'image': return 'Logo / artwork';
      case 'box': return 'Box';
      case 'line': return 'Rule';
      case 'symbol': { var sd = symDef(e.sym); return sd ? sd.name : 'Symbol'; }
      default: return e.type;
    }
  }

  /* ------------------------------------------------------------ pointer UI */
  var drag = null;

  function pointToMm(ev) {
    var rect = canvas.getBoundingClientRect();
    var pxPerMm = currentScale();
    return { x: (ev.clientX - rect.left) / pxPerMm, y: (ev.clientY - rect.top) / pxPerMm };
  }

  function hitTest(pt) {
    for (var i = state.elements.length - 1; i >= 0; i--) {
      var b = bounds(state.elements[i]);
      var pad = 1;
      if (pt.x >= b.x - pad && pt.x <= b.x + b.w + pad && pt.y >= b.y - pad && pt.y <= b.y + b.h + pad) return state.elements[i];
    }
    return null;
  }

  function onHandle(pt, e) {
    if (!e) return false;
    var b = bounds(e);
    var pxPerMm = currentScale();
    var hx = b.x + b.w, hy = b.y + b.h;
    var tol = 8 / pxPerMm;
    return Math.abs(pt.x - hx) < tol && Math.abs(pt.y - hy) < tol;
  }

  function stripImg(e) {
    var copy = {};
    Object.keys(e).forEach(function (k) { if (k !== '_img') copy[k] = e[k]; });
    return copy;
  }

  function bindCanvas() {
    canvas.addEventListener('pointerdown', function (ev) {
      var pt = pointToMm(ev);
      var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
      if (sel && onHandle(pt, sel)) {
        var b0 = bounds(sel);
        drag = { mode: 'resize', el: sel, startPt: pt, start: JSON.parse(JSON.stringify(stripImg(sel))), b0: b0 };
      } else {
        var hit = hitTest(pt);
        selectedId = hit ? hit.id : null;
        if (hit) drag = { mode: 'move', el: hit, startPt: pt, ox: hit.x, oy: hit.y };
        renderLayers();
        renderProps();
      }
      canvas.setPointerCapture(ev.pointerId);
      canvas.classList.toggle('is-grabbing', !!drag);
      draw();
      ev.preventDefault();
    });

    canvas.addEventListener('pointermove', function (ev) {
      var pt = pointToMm(ev);
      if (!drag) {
        var sel = state.elements.filter(function (e) { return e.id === selectedId; })[0];
        canvas.classList.toggle('is-grab', !!hitTest(pt) || onHandle(pt, sel));
        return;
      }
      var e = drag.el;
      if (drag.mode === 'move') {
        e.x = round1(drag.ox + (pt.x - drag.startPt.x));
        e.y = round1(drag.oy + (pt.y - drag.startPt.y));
      } else {
        var dx = pt.x - drag.startPt.x, dy = pt.y - drag.startPt.y;
        if (e.type === 'qr') e.size = Math.max(4, round1(drag.start.size + Math.max(dx, dy)));
        else if (e.type === 'line') e.w = Math.max(2, round1(drag.start.w + dx));
        else if (e.type === 'text' || e.type === 'serial') e.size = Math.max(1.2, round1(drag.start.size * Math.max(0.15, 1 + dy / Math.max(2, drag.b0.h))));
        else {
          e.w = Math.max(3, round1(drag.start.w + dx));
          e.h = Math.max(3, round1(drag.start.h + dy));
          if (e.type === 'image' && drag.start.w > 0) e.h = round1(e.w * (drag.start.h / drag.start.w));
        }
      }
      draw();
      renderProps(true);
    });

    function endDrag(ev) {
      if (drag) { drag = null; renderLayers(); renderProps(); updateAdvice(); }
      canvas.classList.remove('is-grabbing');
      if (ev && ev.pointerId != null && canvas.hasPointerCapture && canvas.hasPointerCapture(ev.pointerId)) {
        canvas.releasePointerCapture(ev.pointerId);
      }
    }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);

    document.addEventListener('keydown', function (ev) {
      if (!selectedId) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
      var e = state.elements.filter(function (x) { return x.id === selectedId; })[0];
      if (!e) return;
      var step = ev.shiftKey ? 5 : 0.5;
      var moved = true;
      if (ev.key === 'ArrowLeft') e.x = round1(e.x - step);
      else if (ev.key === 'ArrowRight') e.x = round1(e.x + step);
      else if (ev.key === 'ArrowUp') e.y = round1(e.y - step);
      else if (ev.key === 'ArrowDown') e.y = round1(e.y + step);
      else if (ev.key === 'Delete' || ev.key === 'Backspace') { removeElement(selectedId); moved = false; }
      else moved = false;
      if (moved) { ev.preventDefault(); draw(); renderProps(true); }
    });
  }

  /** The rectangle artwork can safely occupy: the whole label, or the square
      that fits inside a round one. */
  function fitBox() {
    var W = labelW(), H = labelH();
    if (!isRound()) return { x: 0, y: 0, w: W, h: H };
    // the largest rectangle that fits inside the SAFE ellipse, not just the circle
    var rx = Math.max(1, W / 2 - SAFE_MM), ry = Math.max(1, H / 2 - SAFE_MM);
    var bw = (2 * rx) / Math.SQRT2, bh = (2 * ry) / Math.SQRT2;
    return { x: (W - bw) / 2, y: (H - bh) / 2, w: bw, h: bh };
  }

  /** Refit artwork after the label geometry changes so nothing hangs outside. */
  function clampElements() {
    var box = fitBox();
    state.elements.forEach(function (e) {
      var b = bounds(e);
      var scale = Math.min(1, box.w / Math.max(b.w, 0.001), box.h / Math.max(b.h, 0.001));
      if (scale < 0.999) {
        if (e.type === 'text' || e.type === 'serial') { e.size = round1(e.size * scale); if (e.w) e.w = round1(e.w * scale); }
        else if (e.type === 'qr') e.size = round1(e.size * scale);
        else if (e.type === 'line') e.w = round1(e.w * scale);
        else { e.w = round1(e.w * scale); e.h = round1(e.h * scale); }
        b = bounds(e);
      }
      var maxX = box.x + Math.max(0, box.w - b.w);
      var maxY = box.y + Math.max(0, box.h - b.h);
      var nx = Math.min(Math.max(e.x, box.x), maxX);
      var ny = Math.min(Math.max(e.y, box.y), maxY);
      if (nx !== e.x) e.x = round1(nx);
      if (ny !== e.y) e.y = round1(ny);
    });
  }

  function removeElement(id) {
    state.elements = state.elements.filter(function (e) { return e.id !== id; });
    if (selectedId === id) selectedId = null;
    draw(); renderLayers(); renderProps(); updateAdvice();
  }

  /* ------------------------------------------------------------ layers UI */
  function renderLayers() {
    var wrap = $('[data-eld-layers]');
    var empty = $('[data-eld-layersempty]');
    wrap.innerHTML = '';
    empty.style.display = state.elements.length ? 'none' : 'block';
    state.elements.slice().reverse().forEach(function (e) {
      var b = el('button', 'eld__layer' + (e.id === selectedId ? ' is-on' : ''));
      b.type = 'button';
      b.innerHTML = '<span class="ico"><svg aria-hidden="true"><use href="#eldi-' +
        (e.type === 'serial' ? 'serial' : e.type) + '"/></svg></span>' +
        '<span class="nm">' + esc(elementName(e)) + '</span>' +
        '<span class="ty">' + esc(e.type) + '</span>';
      b.addEventListener('click', function () {
        selectedId = e.id; renderLayers(); renderProps(); draw();
      });
      wrap.appendChild(b);
    });
  }

  /* ------------------------------------------------------- properties UI */
  function field(labelText, inputHtml, help) {
    return '<div class="eld__field"><span class="eld__label">' + labelText + '</span>' + inputHtml +
      (help ? '<p class="eld__help">' + help + '</p>' : '') + '</div>';
  }

  function renderProps(valuesOnly) {
    var host = $('[data-eld-props]');
    var e = state.elements.filter(function (x) { return x.id === selectedId; })[0];
    if (!e) { host.innerHTML = ''; return; }
    if (valuesOnly && host.dataset.for === e.id) {
      $$('[data-p]', host).forEach(function (input) {
        var key = input.getAttribute('data-p');
        if (input.type === 'checkbox') input.checked = !!e[key];
        else if (document.activeElement !== input) input.value = e[key];
      });
      return;
    }

    var html = '<div class="eld__props" data-for="' + e.id + '"><h4>' + esc(elementName(e)) +
      '<span class="eld__btnrow">' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-move="up" aria-label="Bring forward"><svg aria-hidden="true"><use href="#eldi-up"/></svg></button>' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-move="down" aria-label="Send backward"><svg aria-hidden="true"><use href="#eldi-down"/></svg></button>' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-del aria-label="Delete element"><svg aria-hidden="true"><use href="#eldi-trash"/></svg></button>' +
      '</span></h4>';

    if (e.type === 'text') {
      html += field('Text', '<textarea data-p="text" rows="2">' + esc(e.text) + '</textarea>');
      html += '<div class="eld__row-3">' +
        field('Size (mm)', '<input type="number" step="0.1" min="1" data-p="size" value="' + e.size + '">') +
        field('Weight', '<select data-p="weight"><option value="400">Regular</option><option value="600">Semibold</option><option value="700">Bold</option><option value="800">Extra bold</option></select>') +
        field('Align', '<select data-p="align"><option value="left">Left</option><option value="center">Centre</option><option value="right">Right</option></select>') +
        '</div>';
      html += '<div class="eld__row">' +
        field('Wrap width (mm)', '<input type="number" step="0.5" min="4" data-p="w" value="' + e.w + '">') +
        field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">') +
        '</div>';
    } else if (e.type === 'serial') {
      html += '<div class="eld__row-3">' +
        field('Prefix', '<input type="text" data-p="prefix" value="' + esc(e.prefix) + '">') +
        field('Start at', '<input type="number" min="0" step="1" data-p="start" value="' + e.start + '">') +
        field('Digits', '<input type="number" min="1" max="12" step="1" data-p="digits" value="' + e.digits + '">') +
        '</div>';
      html += '<div class="eld__row">' +
        field('Suffix', '<input type="text" data-p="suffix" value="' + esc(e.suffix) + '">') +
        field('Size (mm)', '<input type="number" step="0.1" min="1" data-p="size" value="' + e.size + '">') +
        '</div>';
      html += field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">',
        'The preview shows the first label. We print the full sequence across your run.');
    } else if (e.type === 'barcode') {
      html += field('Symbology', '<select data-p="symbology"><option value="code128">Code 128 &mdash; letters and numbers</option><option value="ean13">EAN-13 &mdash; retail, 13 digits</option></select>');
      html += field('Value', '<input type="text" data-p="value" value="' + esc(e.value) + '">');
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="5" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="4" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<label class="eld__check"><input type="checkbox" data-p="showText"' + (e.showText ? ' checked' : '') + '><span>Print the number underneath</span></label>';
    } else if (e.type === 'qr') {
      html += field('Content', '<input type="text" data-p="value" value="' + esc(e.value) + '">', 'A web address, part number or any short text.');
      html += '<div class="eld__row">' +
        field('Size (mm)', '<input type="number" step="0.5" min="6" data-p="size" value="' + e.size + '">') +
        field('Error correction', '<select data-p="ec"><option value="L">L &mdash; smallest</option><option value="M">M &mdash; standard</option><option value="Q">Q &mdash; rugged</option></select>') +
        '</div>';
    } else if (e.type === 'image') {
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="3" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="3" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<p class="eld__help">Your file stays in your browser for the proof. Email the print-ready original (vector, or 300&thinsp;dpi and up) to ' +
        esc(CFG.email || 'sales@earlsmere.co.uk') + ' when you send the enquiry.</p>';
    } else if (e.type === 'symbol') {
      var sdef = symDef(e.sym);
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="3" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="3" data-p="h" value="' + e.h + '">') +
        '</div>';
      if (sdef && sdef.locked) {
        html += '<p class="eld__help">Safety colours are set by the standard, so this one cannot be recoloured.</p>';
      } else {
        html += field('Colour', '<input type="color" data-p="colour" value="' + (e.colour || '#000000') + '">');
      }
    } else if (e.type === 'box') {
      html += '<div class="eld__row">' +
        field('Width (mm)', '<input type="number" step="0.5" min="2" data-p="w" value="' + e.w + '">') +
        field('Height (mm)', '<input type="number" step="0.5" min="2" data-p="h" value="' + e.h + '">') +
        '</div>';
      html += '<div class="eld__row-3">' +
        field('Line (mm)', '<input type="number" step="0.1" min="0" data-p="strokeW" value="' + e.strokeW + '">') +
        field('Line colour', '<input type="color" data-p="stroke" value="' + e.stroke + '">') +
        field('Radius (mm)', '<input type="number" step="0.5" min="0" data-p="radius" value="' + e.radius + '">') +
        '</div>';
      html += field('Fill', '<select data-p="fill"><option value="none">No fill</option><option value="#000000">Black</option><option value="#ffffff">White</option><option value="#00A0DF">Earlsmere blue</option><option value="#ffe14d">Yellow</option><option value="#e8443a">Red</option></select>');
    } else if (e.type === 'line') {
      html += '<div class="eld__row-3">' +
        field('Length (mm)', '<input type="number" step="0.5" min="2" data-p="w" value="' + e.w + '">') +
        field('Thickness', '<input type="number" step="0.1" min="0.1" data-p="thickness" value="' + e.thickness + '">') +
        field('Colour', '<input type="color" data-p="colour" value="' + e.colour + '">') +
        '</div>';
    }

    html += '<div class="eld__row-3">' +
      field('X (mm)', '<input type="number" step="0.5" data-p="x" value="' + e.x + '">') +
      field('Y (mm)', '<input type="number" step="0.5" data-p="y" value="' + e.y + '">') +
      '<div class="eld__field"><span class="eld__label">&nbsp;</span><button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-centre style="width:100%">Centre</button></div>' +
      '</div>';
    html += '</div>';

    host.innerHTML = html;
    host.dataset.for = e.id;

    $$('[data-p]', host).forEach(function (input) {
      var key = input.getAttribute('data-p');
      if (input.tagName === 'SELECT') input.value = String(e[key]);
      if (input.type === 'checkbox') input.checked = !!e[key];
      var evName = (input.tagName === 'SELECT' || input.type === 'checkbox' || input.type === 'color') ? 'change' : 'input';
      input.addEventListener(evName, function () {
        var v;
        if (input.type === 'checkbox') v = input.checked;
        else if (input.type === 'number') v = parseFloat(input.value);
        else v = input.value;
        if (input.type === 'number' && !isFinite(v)) return;
        if (key === 'weight' || key === 'digits' || key === 'start') v = parseInt(input.value, 10) || 0;
        e[key] = v;
        draw(); renderLayers(); updateAdvice();
      });
    });

    $('[data-del]', host).addEventListener('click', function () { removeElement(e.id); });
    $('[data-centre]', host).addEventListener('click', function () {
      var b = bounds(e);
      e.x = round1((labelW() - b.w) / 2);
      e.y = round1((labelH() - b.h) / 2);
      draw(); renderProps();
    });
    $$('[data-move]', host).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = state.elements.indexOf(e);
        var j = btn.getAttribute('data-move') === 'up' ? i + 1 : i - 1;
        if (j < 0 || j >= state.elements.length) return;
        state.elements.splice(i, 1);
        state.elements.splice(j, 0, e);
        draw(); renderLayers();
      });
    });
  }

  /* --------------------------------------------------------------- advice */
  function adviceList() {
    var out = [];
    var env = state.env;
    var lam = isLaminated();
    var paper = isPaper();
    var wet = env.outdoor || env.chem || env.abrasion;
    var mat = LABELS.material[state.material];

    /* Material first. Laminating paper does not make it a synthetic — if the label
       is going somewhere wet, the face stock is the thing that has to change. */
    if (paper && wet) out.push(['warn', mat + ' is a paper face. Outdoors, near chemicals or through a washdown it will ' +
      'cockle and tear whatever we laminate it with. Polypropylene or polyester is the right face here.']);
    else if (paper && env.cold) out.push(['warn', mat + ' will lift and wrinkle as condensation gets under it. ' +
      'For chilled or frozen, use polypropylene or polyester.']);
    else if (paper) out.push(['note', mat + ' is the most economical face and prints beautifully. It is an indoor, dry-use material.']);

    if (state.material === 'pet' && !wet && !env.cold) out.push(['note',
      'Polyester is our toughest face — worth it for chemicals, heat or a long service life. ' +
      'Polypropylene costs less if none of that applies.']);
    if (state.material === 'pet' && env.chem) out.push(['good', 'Polyester is the right call against solvents and cleaning agents.']);
    if (state.material === 'pp' && wet) out.push(['good', 'Polypropylene is a sound choice for this — tough, and it shrugs off moisture.']);

    /* Then lamination, which protects the print rather than the face. */
    if (env.outdoor && !lam) out.push(['warn', 'Outdoors and in sunlight, an unlaminated print will fade and scuff within a season. Laminate it.']);
    if (env.chem && !lam) out.push(['warn', 'Solvents and cleaning agents will lift unlaminated digital ink. A laminate is the barrier that stops it.']);
    if (env.abrasion && !lam) out.push(['warn', 'If it gets handled hard or washed down, laminate it — the film takes the punishment instead of the print.']);
    if (lam && !wet) out.push(['note', 'Laminate is doing little here beyond a nicer finish. Unlaminated costs less if budget matters.']);
    if (state.finish === 'gloss' && env.outdoor) out.push(['note',
      'Gloss lifts the colour but throws glare in sunlight. Matt is easier to read outdoors.']);

    /* And the adhesive, which is about the surface it goes on rather than the weather. */
    if (state.adhesive === 'peel' && wet) out.push(['warn',
      'A peelable adhesive is made to come off cleanly, so outdoors or through a washdown it will lift at the edges. ' +
      'Permanent is safer unless the label genuinely has to be removed.']);
    if (state.adhesive === 'peel' && env.cold) out.push(['warn',
      'Peelable adhesives go hard and let go below freezing. Tell us the application temperature in the notes.']);
    if (state.adhesive === 'perm' && env.cold) out.push(['note',
      'For chilled or frozen use, say so in the notes and we will match a freezer-grade permanent adhesive.']);
    if (state.adhesive === 'xperm') out.push(['note',
      'Extra permanent is for the awkward surfaces — powder coat, textured plastic, drums. On smooth stock it is more than you need.']);

    if (labelW() > MAX_1UP) out.push(['warn', 'At ' + fmtMm(labelW()) + ' mm wide this is past our ' + MAX_1UP + ' mm limit. Bring the width down, or give us a call.']);
    else if (labelW() > MAX_3UP) out.push(['note', 'Over ' + MAX_3UP + ' mm wide, so it runs one across the web rather than three. Perfectly normal — it just uses more material per label.']);

    if (state.bg && state.bg.toLowerCase() !== '#ffffff') out.push(['note', 'A solid background colour is fine on digital print, and it costs the same as white.']);

    var over = state.elements.filter(function (e) {
      var b = bounds(e);
      if (isRound()) {
        var rx = labelW() / 2 - SAFE_MM, ry = labelH() / 2 - SAFE_MM;
        var cx = labelW() / 2, cy = labelH() / 2;
        if (rx <= 0 || ry <= 0) return true;
        var corners = [[b.x, b.y], [b.x + b.w, b.y], [b.x, b.y + b.h], [b.x + b.w, b.y + b.h]];
        return corners.some(function (p) {
          var dx = (p[0] - cx) / rx, dy = (p[1] - cy) / ry;
          return dx * dx + dy * dy > 1.02;
        });
      }
      return b.x < SAFE_MM - 0.25 || b.y < SAFE_MM - 0.25 ||
        b.x + b.w > labelW() - SAFE_MM + 0.25 || b.y + b.h > labelH() - SAFE_MM + 0.25;
    });
    if (over.length) out.push(['warn', over.length + (over.length === 1 ? ' element crosses' : ' elements cross') +
      ' the ' + SAFE_MM + ' mm safe margin. Anything past the dashed line risks being trimmed off.']);

    state.elements.filter(function (e) { return e.type === 'barcode'; }).forEach(function (e) {
      if (e.h < 8) out.push(['warn', 'That barcode is under 8 mm tall. Most handheld scanners want at least 10 mm to read reliably.']);
      if (!barcodeBits(e.symbology, e.value)) out.push(['warn', 'The barcode value is not valid for ' + (e.symbology === 'ean13' ? 'EAN-13 (needs 12 or 13 digits)' : 'Code 128') + '.']);
    });
    state.elements.filter(function (e) { return e.type === 'qr'; }).forEach(function (e) {
      if (e.size < 10) out.push(['warn', 'QR codes under 10 mm can be unreliable once printed. 15 mm or more is safer.']);
      if (!qrEncode(e.value, e.ec)) out.push(['warn', 'That QR content is empty or too long for a printable code.']);
    });

    if (!out.length) out.push(['good', 'Nothing looks wrong with this spec. Move on to artwork when you are happy.']);
    return out;
  }

  function updateAdvice() {
    var host = $('[data-eld-advice]');
    if (!host) return;
    host.innerHTML = adviceList().map(function (a) {
      var cls = a[0] === 'warn' ? 'eld__note eld__note--warn' : a[0] === 'good' ? 'eld__note eld__note--good' : 'eld__note';
      return '<div class="' + cls + '">' + esc(a[1]) + '</div>';
    }).join('');
  }

  /* -------------------------------------------------------------- summary */
  function specRows() {
    var run = runInfo();
    var rows = [
      ['Shape', LABELS.shape[state.shape] + (!isRound() && state.radius > 0 ? ', ' + fmtMm(state.radius) + ' mm corners' : '')],
      ['Size', isRound() ? fmtMm(labelW()) + ' mm diameter' : fmtMm(labelW()) + ' × ' + fmtMm(labelH()) + ' mm'],
      ['Print', 'Full-colour digital'],
      ['Material', LABELS.material[state.material]],
      ['Adhesive', LABELS.adhesive[state.adhesive]],
      ['Finish', LABELS.finish[state.finish]],
      ['Background', state.bg],
      ['Layout', run.across + ' across the ' + WEB_MM + ' mm web'],
      ['Quantity', fmtInt(run.rounded) + ' labels'],
      ['Run length', '≈ ' + run.lengthM.toFixed(1) + ' m of web']
    ];
    var envOn = Object.keys(state.env).filter(function (k) { return state.env[k]; });
    if (envOn.length) {
      rows.push(['Environment', envOn.map(function (k) {
        return { outdoor: 'Outdoor / UV', cold: 'Chilled or frozen', chem: 'Chemicals', abrasion: 'Abrasion or washdown' }[k];
      }).join(', ')]);
    }
    var counts = {};
    state.elements.forEach(function (e) { counts[e.type] = (counts[e.type] || 0) + 1; });
    var art = Object.keys(counts).map(function (k) { return counts[k] + ' × ' + k; }).join(', ');
    rows.push(['Artwork', art || 'None yet']);
    if (state.deadline) rows.push(['Needed by', state.deadline]);
    if (state.sample) rows.push(['Sample first', 'Yes, please']);
    if (state.repeat) rows.push(['Repeat order', 'Hold the artwork on file']);
    return rows;
  }

  function renderSummary() {
    var host = $('[data-eld-summary]');
    host.innerHTML = '<dl>' + specRows().map(function (r) {
      return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>';
    }).join('') + '</dl>';
  }

  function renderRunInfo() {
    var host = $('[data-eld-runinfo]');
    if (!host) return;
    var run = runInfo();
    var note = run.rounded !== Math.round(state.quantity)
      ? ' We cut in rows of ' + run.across + ', so this rounds up to ' + fmtInt(run.rounded) + '.'
      : '';
    host.innerHTML = '<div class="eld__note">' +
      '<strong>' + fmtInt(run.rounded) + ' labels</strong> = ' + fmtInt(run.rows) + ' rows of ' + run.across +
      ', about ' + run.lengthM.toFixed(1) + ' m of ' + WEB_MM + ' mm web.' + esc(note) +
      '</div>';
  }

  function specText() {
    var lines = specRows().map(function (r) { return r[0] + ': ' + r[1]; });
    state.elements.forEach(function (e, i) {
      var d = '  ' + (i + 1) + '. ' + e.type + ' @ ' + fmtMm(e.x) + ',' + fmtMm(e.y) + 'mm';
      if (e.type === 'text') d += ' — "' + String(e.text).replace(/\n/g, ' / ') + '" ' + e.size + 'mm';
      if (e.type === 'serial') d += ' — ' + serialSample(e) + ' incrementing';
      if (e.type === 'barcode') d += ' — ' + (e.symbology === 'ean13' ? 'EAN-13' : 'Code 128') + ' "' + e.value + '" ' + fmtMm(e.w) + '×' + fmtMm(e.h) + 'mm';
      if (e.type === 'qr') d += ' — QR "' + e.value + '" ' + fmtMm(e.size) + 'mm';
      if (e.type === 'symbol') { var sy = symDef(e.sym); d += ' — ' + (sy ? sy.name : e.sym) + ', ' + fmtMm(e.w) + '×' + fmtMm(e.h) + 'mm'; }
      if (e.type === 'image') d += ' — customer artwork' + (e.fileName ? ' (' + e.fileName + ')' : '') + ', ' + fmtMm(e.w) + '×' + fmtMm(e.h) + 'mm';
      lines.push(d);
    });
    return lines.join('\n');
  }

  /* The customer's original artwork is far too heavy to travel in an enquiry, so we
     keep a small flattened copy purely so the proof can be rebuilt with their logo on
     it. Print quality is not the point here — recognising the label is. */
  var CODE_IMG_PX = 340;        // longest edge
  var CODE_IMG_MAX = 20000;     // base64 characters we are willing to carry

  function shrinkForCode(img) {
    try {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return '';
      var scale = Math.min(1, CODE_IMG_PX / Math.max(w, h));
      var quality = 0.62;

      for (var attempt = 0; attempt < 5; attempt++) {
        var c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(w * scale));
        c.height = Math.max(1, Math.round(h * scale));
        var cc = c.getContext('2d');
        cc.fillStyle = state.bg || '#ffffff';        // flatten transparency onto the label
        cc.fillRect(0, 0, c.width, c.height);
        cc.drawImage(img, 0, 0, c.width, c.height);
        var url = c.toDataURL('image/jpeg', quality);
        if (url.length <= CODE_IMG_MAX) return url;
        scale *= 0.72;
        quality = Math.max(0.4, quality - 0.08);
      }
    } catch (err) { /* tainted canvas or no support: fall through */ }
    return '';                                       // too heavy: send the spec without it
  }

  function designCode() {
    try {
      var clean = JSON.parse(JSON.stringify({
        v: 2, w: state.w, h: state.h, shape: state.shape, radius: state.radius,
        material: state.material, adhesive: state.adhesive,
        finish: state.finish, bg: state.bg, quantity: state.quantity,
        env: state.env,
        elements: state.elements.map(function (e) {
          var c = stripImg(e);
          if (c.type === 'image') c.src = e._small || '';
          delete c._small;
          return c;
        })
      }));
      return btoa(unescape(encodeURIComponent(JSON.stringify(clean))));
    } catch (err) { return ''; }
  }

  /* A link that reopens this exact label with its proof on screen. Long designs
     would make a URL that email clients wrap and break, so past a safe length we
     fall back to the pasteable code alone. */
  var MAX_LINK_CHARS = 1900;

  function proofLink(code) {
    if (!code) return '';
    try {
      var base = window.location.origin + window.location.pathname;
      var url = base + '?eld=' + encodeURIComponent(code) + '&proof=1';
      return url.length > MAX_LINK_CHARS ? '' : url;
    } catch (err) { return ''; }
  }

  /* ----------------------------------------------------------- proof export */
  function proofDataUrl() {
    var pxPerMm = PROOF_DPI / 25.4;
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(labelW() * pxPerMm));
    c.height = Math.max(1, Math.round(labelH() * pxPerMm));
    var cc = c.getContext('2d');
    cc.fillStyle = '#ffffff';
    cc.fillRect(0, 0, c.width, c.height);
    renderTo(cc, pxPerMm, { guides: false, selection: false });
    return c.toDataURL('image/png');
  }

  /* On claude.ai the page cannot start a download itself, so use the host's
     save surface when it is offered. Everywhere else (your Shopify store, a
     local file) the ordinary download link is exactly right. */
  var hostSave = null;
  if (window.claude && typeof window.claude.use === 'function') {
    try { window.claude.use('downloads').then(function (d) { hostSave = d; }, function () {}); }
    catch (err) { /* nothing to do */ }
  }

  function dataUrlToBytes(url) {
    var b64 = url.split(',')[1] || '';
    var bin = atob(b64);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return bytes;
  }

  function saveProof(url, btn) {
    var filename = 'earlsmere-label-' + fmtMm(labelW()) + 'x' + fmtMm(labelH()) + 'mm.png';
    if (hostSave && typeof hostSave.save === 'function') {
      btn.disabled = true;
      hostSave.save({ filename: filename, data: dataUrlToBytes(url) })
        .then(function () { btn.disabled = false; })
        .catch(function (err) {
          btn.disabled = false;
          if (err && err.code === 'declined') return;
          window.alert('That download was not allowed here. Right-click the proof and choose "Save image as…" instead.');
        });
      return;
    }
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  function openProof() {
    var url = proofDataUrl();
    $('[data-eld-proofimg]').src = url;
    $('[data-eld-proofmeta]').textContent =
      (isRound() ? fmtMm(labelW()) + ' mm diameter' : fmtMm(labelW()) + ' × ' + fmtMm(labelH()) + ' mm') +
      ' · full-colour digital on ' + LABELS.material[state.material].toLowerCase() +
      ' · ' + LABELS.adhesive[state.adhesive].toLowerCase() + ' adhesive · ' +
      LABELS.finish[state.finish].toLowerCase();
    $('[data-eld-modal]').classList.add('is-open');
    var btn = $('[data-eld-proofdl]');
    btn.onclick = function () { saveProof(url, btn); };
  }

  /* ------------------------------------------------------------ quote send */
  function quoteBody() {
    var code = designCode();
    var link = proofLink(code);
    var hasLogo = state.elements.some(function (e) { return e.type === 'image'; });
    return [
      'LABEL DESIGNER ENQUIRY — full-colour digital on ' +
        LABELS.material[state.material].toLowerCase(),
      '',
      specText(),
      '',
      state.notes ? 'Customer notes: ' + state.notes : '',
      '',
      link ? 'SEE THEIR PROOF — opens this exact label, ready to download at 300 dpi:' : '',
      link || '',
      link ? '' : 'SEE THEIR PROOF — this design is too big for a link'
        + (hasLogo ? ', because it carries their logo' : '')
        + '. Copy the code at the bottom of this email, open the designer, and paste it into'
        + ' "Open a design code" under the preview.',
      '',
      hasLogo
        ? 'Their logo shows on the proof, but only as a screen-quality copy — the print-ready'
          + ' original never leaves their machine, so ask them to email it over.'
        : '',
      '',
      link ? 'Design code (paste it in if the link above wraps):' : 'Design code:',
      code
    ].filter(function (l) { return l !== ''; }).join('\n');
  }

  /* The spec is carried in a hidden contact[Comment] field. Keep it current rather
     than filling it at the last moment: Shopify's spam protection cancels the submit,
     fetches a captcha token and re-submits the form itself, and that re-submission
     does not always come back through our handler. */
  function syncQuoteField() {
    var body = $('[data-eld-qf="body"]');
    if (body) body.value = quoteBody();
  }

  function quoteResult(ok) {
    var out = $('[data-eld-quoteresult]');
    if (!out) return;
    if (ok) {
      out.innerHTML = '<div class="eld__note eld__note--good"><strong>Sent — thank you.</strong> ' +
        'We will come back with a price, usually the same working day. ' +
        (state.elements.some(function (e) { return e.type === 'image'; })
          ? 'Please email your print-ready logo file to ' + esc(CFG.email || 'sales@earlsmere.co.uk') + ' so we can match it exactly.'
          : '') + '</div>';
      return;
    }
    var subject = 'Label designer enquiry — ' + fmtMm(labelW()) + ' x ' + fmtMm(labelH()) + 'mm';
    var href = 'mailto:' + (CFG.email || 'sales@earlsmere.co.uk') +
      '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(quoteBody().slice(0, 1800));
    out.innerHTML = '<div class="eld__note eld__note--warn"><strong>That did not send.</strong> ' +
      '<a href="' + href + '">Open it in your email app</a> instead, or call ' + esc(CFG.phone || '01226 750 111') + '. ' +
      '<button type="button" class="eld__btn eld__btn--ghost eld__btn--sm" data-copy style="margin-top:8px">Copy the spec</button></div>';
    var copy = out.querySelector('[data-copy]');
    if (copy) copy.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(quoteBody());
      copy.textContent = 'Copied';
    });
  }

  /* The form posts itself. We only top up the spec, remember the design across the
     round trip, and put a safety net under it if nothing happens. */
  function onQuoteSubmit(ev) {
    var form = ev.currentTarget;
    if (form.checkValidity && !form.checkValidity()) return;   // let the browser prompt

    syncQuoteField();

    try {
      window.sessionStorage.setItem(SENT_KEY, JSON.stringify({
        code: designCode(),
        hasArtwork: state.elements.some(function (e) { return e.type === 'image'; })
      }));
    } catch (err) { /* private browsing: the enquiry still sends */ }

    if (!IS_SHOPIFY) {                                          // local preview build
      ev.preventDefault();
      quoteResult(true);
      $('[data-eld-quoteresult]').insertAdjacentHTML('beforeend',
        '<div class="eld__note" style="margin-top:9px">This is the preview build, so nothing was actually emailed. ' +
        'On your Shopify store this posts straight to your contact form.</div>');
      return;
    }

    var btn = $('[data-eld-send]');
    if (btn) { btn.disabled = true; btn.innerHTML = '<span class="eld__spinner"></span>Sending…'; }

    /* Shopify cancels the submit, gets its token and re-submits. If we are still
       sitting here well after that should have happened, say so instead of leaving
       the customer staring at a spinner. */
    window.setTimeout(function () {
      if (document.hidden) return;
      if (document.querySelector('iframe[src*="hcaptcha"],iframe[src*="recaptcha"],.h-captcha,#shopify-challenge')) return;
      if (btn) { btn.disabled = false; btn.textContent = 'Send enquiry'; }
      quoteResult(false);
    }, 20000);
  }

  /* Shopify has redirected back after a successful post: rebuild the label the
     customer sent and confirm it, instead of dumping them on a blank designer. */
  function restoreAfterPost() {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;

    var saved = null;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(SENT_KEY) || 'null');
      window.sessionStorage.removeItem(SENT_KEY);
    } catch (err) { /* nothing saved */ }

    if (saved && saved.code) { try { loadCode(saved.code); } catch (err) { /* show the note anyway */ } }

    setStep('order');
    $('[data-eld-quoteresult]').innerHTML =
      '<div class="eld__note eld__note--good"><strong>Sent — thank you.</strong> ' +
      'We will come back with a price, usually the same working day. ' +
      (saved && saved.hasArtwork
        ? 'Please email your print-ready logo file to ' + esc(CFG.email || 'sales@earlsmere.co.uk') + ' so we can match it exactly.'
        : '') + '</div>';

    /* Drop the query string so a refresh doesn't replay the confirmation. */
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname + window.location.hash);
    }
    var box = $('[data-eld-quoteresult]');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'center' });
  }

  /* ------------------------------------------------------------- binding */
  function setStep(name) {
    $$('[data-eld-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', String(b.getAttribute('data-eld-tab') === name));
    });
    $$('[data-eld-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-eld-panel') === name);
    });
    if (name === 'order') { renderSummary(); syncQuoteField(); }
    if (name === 'quantity') renderRunInfo();
    if (name === 'material') updateAdvice();
    var hints = {
      size: 'Up to ' + MAX_3UP + ' mm wide runs three across the web; wider runs one across.',
      material: 'Tell us where the label lives and we will say whether it needs laminating.',
      design: state.elements.length
        ? 'Click an element to select it, then drag to move. Arrow keys nudge.'
        : 'Add text, a logo or a barcode above to start laying out your label.',
      quantity: 'Digital print has no plate cost, so short runs are genuinely economical.',
      order: 'Send us the design and we will price it, usually the same working day.'
    };
    $('[data-eld-stagehint]').textContent = hints[name] || '';
  }

  function sizeChip(host, s) {
    var b = el('button', 'eld__chip');
    b.type = 'button';
    b.textContent = fmtMm(s[0]) + ' × ' + fmtMm(s[1]);
    b.addEventListener('click', function () {
      state.shape = 'rect';
      $$('input[name="eld-shape"]').forEach(function (r) { r.checked = r.value === 'rect'; });
      $$('.eld__opt').forEach(function (lab) {
        var i = lab.querySelector('input');
        lab.classList.toggle('is-on', !!(i && i.checked));
      });
      applyShapeUI();
      state.w = s[0]; state.h = s[1];
      $('[data-eld="w"]').value = s[0];
      $('[data-eld="h"]').value = s[1];
      $('[data-eld-one]').value = s[0];
      clampElements(); syncSizeChips(); renderLayout(); draw(); updateAdvice();
    });
    host.appendChild(b);
  }

  function bindSizes() {
    SIZES_3UP.forEach(function (s) { sizeChip($('[data-eld-sizes3]'), s); });
    SIZES_1UP.forEach(function (s) { sizeChip($('[data-eld-sizes1]'), s); });
    $('[data-eld-max3]').textContent = MAX_3UP;
    $('[data-eld-max1]').textContent = MAX_1UP;

    var qhost = $('[data-eld-qtychips]');
    QTY_CHIPS.forEach(function (q) {
      var b = el('button', 'eld__chip');
      b.type = 'button';
      b.textContent = fmtInt(q);
      b.addEventListener('click', function () {
        state.quantity = q;
        $('[data-eld="quantity"]').value = q;
        syncQtyChips(); renderRunInfo();
      });
      qhost.appendChild(b);
    });
  }

  function allSizes() { return SIZES_3UP.concat(SIZES_1UP); }

  function syncSizeChips() {
    var all = allSizes();
    var chips = $$('[data-eld-sizes3] .eld__chip').concat($$('[data-eld-sizes1] .eld__chip'));
    chips.forEach(function (b, i) {
      b.classList.toggle('is-on', state.shape === 'rect' && all[i][0] === state.w && all[i][1] === state.h);
    });
  }

  function syncQtyChips() {
    $$('[data-eld-qtychips] .eld__chip').forEach(function (b, i) {
      b.classList.toggle('is-on', QTY_CHIPS[i] === Number(state.quantity));
    });
  }

  function applyShapeUI() {
    var rect = state.shape === 'rect';
    $('[data-eld-dims="rect"]').style.display = rect ? '' : 'none';
    $('[data-eld-dims="one"]').style.display = rect ? 'none' : '';
    $('[data-eld-dlabel]').textContent = state.shape === 'circle' ? 'Diameter (mm)' : 'Size across (mm)';
    $('[data-eld-radiusfield]').style.display = isRound() ? 'none' : '';
    if (!rect) $('[data-eld-one]').value = state.w;
  }


  /* ------------------------------------------------------------- symbols */
  /* Thumbnails are built from the same path data the canvas draws, so the
     picker can never drift from the artwork. "@" means "the customer's colour",
     which in a thumbnail is just ink. */
  var symCat = 'All';

  function symbolThumb(def) {
    var inner = (def.paths || []).map(function (p) {
      var a = 'd="' + p.d + '"';
      a += ' fill="' + (p.f ? (p.f === '@' ? '#1a1a1a' : p.f) : 'none') + '"';
      if (p.fr) a += ' fill-rule="' + p.fr + '"';
      if (p.s) a += ' stroke="' + (p.s === '@' ? '#1a1a1a' : p.s) + '" stroke-width="' + (p.sw == null ? 6 : p.sw) +
                    '" stroke-linecap="round" stroke-linejoin="round"';
      return '<path ' + a + '/>';
    }).join('');
    return '<svg viewBox="0 0 100 100" aria-hidden="true">' + inner + '</svg>';
  }

  function renderSymbols() {
    var grid = $('[data-eld-symbols-grid]');
    var empty = $('[data-eld-symbols-empty]');
    if (!grid) return;
    var q = (($('[data-eld-symbols-search]') || {}).value || '').trim().toLowerCase();
    var list = SYMBOLS.filter(function (d) {
      if (symCat !== 'All' && d.cat !== symCat) return false;
      if (!q) return true;
      return (d.name + ' ' + d.cat + ' ' + d.id).toLowerCase().indexOf(q) !== -1;
    });
    grid.innerHTML = list.map(function (d) {
      return '<button type="button" class="eld__symbols-item" data-eld-symbol="' + esc(d.id) + '" title="' +
        esc(d.name) + '">' + symbolThumb(d) + '<span class="nm">' + esc(d.name) + '</span></button>';
    }).join('');
    if (empty) empty.hidden = list.length > 0;

    $$('[data-eld-symbol]', grid).forEach(function (b) {
      b.addEventListener('click', function () {
        makeElement('symbol', { sym: b.getAttribute('data-eld-symbol') });
        $('[data-eld-symbols]').hidden = true;
        draw(); renderLayers(); renderProps(); updateAdvice();
      });
    });
  }

  function renderSymbolCats() {
    var host = $('[data-eld-symbols-cats]');
    if (!host) return;
    var cats = ['All'];
    SYMBOLS.forEach(function (d) { if (cats.indexOf(d.cat) === -1) cats.push(d.cat); });
    host.innerHTML = cats.map(function (c) {
      return '<button type="button" class="eld__symbols-cat' + (c === symCat ? ' is-on' : '') +
        '" data-eld-symbols-cat="' + esc(c) + '">' + esc(c) + '</button>';
    }).join('');
    $$('[data-eld-symbols-cat]', host).forEach(function (b) {
      b.addEventListener('click', function () {
        symCat = b.getAttribute('data-eld-symbols-cat');
        renderSymbolCats(); renderSymbols();
      });
    });
  }

  var symBound = false;
  /* The full ISO library runs well over a megabyte, so it lives in its own asset and
     only arrives if somebody actually opens the picker. Everyone else pays nothing. */
  var symLoading = false, symDone = false, symWaiting = [];
  function loadSymbolLibrary(then) {
    if (symDone || !CFG.symbolsUrl) { then(); return; }
    symWaiting.push(then);
    if (symLoading) return;                 // already on its way: wait, don't redraw early
    symLoading = true;

    var grid = $('[data-eld-symbols-grid]');
    if (grid) grid.innerHTML = '<p class="eld__symbols-empty">Loading symbols…</p>';

    function finish() {
      symDone = true;
      var queue = symWaiting; symWaiting = [];
      queue.forEach(function (fn) { fn(); });
    }
    window.__ELD_SYMBOLS_READY = function () {
      SYMBOLS = window.__ELD_SYMBOLS || SYMBOLS;
      finish();
    };
    var sc = document.createElement('script');
    sc.src = CFG.symbolsUrl;
    sc.onerror = function () {
      if (grid) grid.innerHTML = '<p class="eld__symbols-empty">The symbol library did not load — ' +
        'the basic shapes still work.</p>';
      finish();
    };
    document.head.appendChild(sc);
  }

  function bindSymbolPicker() {
    if (symBound) return;
    symBound = true;
    var panel = $('[data-eld-symbols]');
    var open = $('[data-eld-symbols-open]');
    if (!panel || !open) return;
    if (!SYMBOLS.length && !CFG.symbolsUrl) { open.hidden = true; return; }
    open.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        loadSymbolLibrary(function () { renderSymbolCats(); renderSymbols(); });
        var s = $('[data-eld-symbols-search]');
        if (s) s.focus();
      }
    });
    var close = $('[data-eld-symbols-close]');
    if (close) close.addEventListener('click', function () { panel.hidden = true; });
    var search = $('[data-eld-symbols-search]');
    if (search) search.addEventListener('input', renderSymbols);
  }

  function bindInputs() {
    bindSymbolPicker();

    $$('[data-eld]').forEach(function (input) {
      var key = input.getAttribute('data-eld');
      if (input.type === 'checkbox') input.checked = !!state[key];
      else if (state[key] != null) input.value = state[key];

      var evName = (input.tagName === 'SELECT' || input.type === 'checkbox' || input.type === 'color') ? 'change' : 'input';
      input.addEventListener(evName, function () {
        if (input.type === 'checkbox') state[key] = input.checked;
        else if (input.type === 'number') {
          var limits = { w: [6, MAX_1UP], h: [6, MAX_H], radius: [0, 12], quantity: [1, 10000000] };
          var lim = limits[key] || [-1e9, 1e9];
          state[key] = num(input.value, lim[0], lim[1], state[key]);
        } else state[key] = input.value;

        if (key === 'radius') $('[data-eld-radiusval]').textContent = fmtMm(state.radius);
        if (key === 'w' || key === 'h') { clampElements(); syncSizeChips(); renderLayout(); }
        if (key === 'quantity') { syncQtyChips(); renderRunInfo(); }
        if (key === 'bg') $('[data-eld-bgpreset]').value = state.bg;
        draw(); updateAdvice(); syncQuoteField();
      });

      // Numbers get clamped as they are typed; put the clamped value back in
      // the box when the field loses focus so what you see is what we quoted.
      if (input.type === 'number') {
        input.addEventListener('change', function () {
          if (String(state[key]) !== input.value) input.value = state[key];
          if (key === 'w' || key === 'h') $('[data-eld-one]').value = state.w;
        });
      }
    });

    // single-dimension input, used for square and circle
    var oneInput = $('[data-eld-one]');
    oneInput.addEventListener('input', function () {
      state.w = num(this.value, 6, MAX_1UP, state.w);
      state.h = state.w;
      $('[data-eld="w"]').value = state.w;
      $('[data-eld="h"]').value = state.h;
      clampElements(); syncSizeChips(); renderLayout(); draw(); updateAdvice();
    });
    oneInput.addEventListener('change', function () {
      if (String(state.w) !== this.value) this.value = state.w;
    });

    function syncOptCards() {
      $$('.eld__opt').forEach(function (lab) {
        var input = lab.querySelector('input');
        lab.classList.toggle('is-on', !!(input && input.checked));
      });
    }
    $$('.eld__opt input').forEach(function (i) { i.addEventListener('change', syncOptCards); });
    syncOptCards();

    $$('input[name="eld-shape"]').forEach(function (r) {
      r.addEventListener('change', function () {
        state.shape = r.value;
        if (state.shape !== 'rect') state.h = state.w;
        applyShapeUI();
        $('[data-eld="h"]').value = state.h;
        clampElements(); syncSizeChips(); renderLayout(); draw(); updateAdvice();
      });
    });
    $$('input[name="eld-finish"]').forEach(function (r) {
      r.addEventListener('change', function () { state.finish = r.value; updateAdvice(); draw(); });
    });
    $$('input[name="eld-material"]').forEach(function (r) {
      r.addEventListener('change', function () { state.material = r.value; updateAdvice(); draw(); });
    });
    $$('input[name="eld-adhesive"]').forEach(function (r) {
      r.addEventListener('change', function () { state.adhesive = r.value; updateAdvice(); });
    });
    $$('[data-eld-env]').forEach(function (c) {
      c.addEventListener('change', function () {
        state.env[c.getAttribute('data-eld-env')] = c.checked;
        updateAdvice();
      });
    });
    $('[data-eld-bgpreset]').addEventListener('change', function () {
      state.bg = this.value;
      $('[data-eld="bg"]').value = state.bg;
      draw(); updateAdvice();
    });

    $$('[data-eld-tab]').forEach(function (b) {
      b.addEventListener('click', function () { setStep(b.getAttribute('data-eld-tab')); });
    });
    $$('[data-eld-next]').forEach(function (b) {
      b.addEventListener('click', function () { setStep(b.getAttribute('data-eld-next')); });
    });

    $$('[data-eld-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var type = b.getAttribute('data-eld-add');
        if (type === 'image') { $('[data-eld-file]').click(); return; }
        makeElement(type);
        draw(); renderLayers(); renderProps(); updateAdvice();
      });
    });

    $('[data-eld-file]').addEventListener('change', function () {
      var file = this.files && this.files[0];
      if (!file) return;
      if (file.size > 6 * 1024 * 1024) {
        window.alert('That file is over 6 MB. Please use a smaller version for the proof and email us the print-ready original.');
        this.value = '';
        return;
      }
      var reader = new FileReader();
      reader.onload = function (ev) {
        var img = new Image();
        img.onload = function () {
          var maxW = labelW() * 0.6;
          var ratio = img.naturalHeight / img.naturalWidth;
          var e = makeElement('image', { src: ev.target.result, w: round1(maxW), h: round1(maxW * ratio) });
          e._img = img;
          e.fileName = file.name;
          e._small = shrinkForCode(img);   // a light copy that can travel in the design code
          draw(); renderLayers(); renderProps(); updateAdvice();
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
      this.value = '';
    });

    $$('[data-eld-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var base = currentScale();
        zoom = b.getAttribute('data-eld-zoom') === '+' ? base * 1.25 : base / 1.25;
        if (zoom < fitScale() * 0.55) zoom = 0;
        draw();
      });
    });
    $('[data-eld-guides]').addEventListener('change', function () { showGuides = this.checked; draw(); });

    $('[data-eld-proof]').addEventListener('click', openProof);
    $$('[data-eld-close]').forEach(function (b) {
      b.addEventListener('click', function () { $('[data-eld-modal]').classList.remove('is-open'); });
    });
    $('[data-eld-modal]').addEventListener('click', function (ev) {
      if (ev.target === this) this.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') $('[data-eld-modal]').classList.remove('is-open');
    });
    var quoteForm = $('[data-eld-quoteform]');
    if (quoteForm) quoteForm.addEventListener('submit', onQuoteSubmit);

    var codeLoad = $('[data-eld-codeload]');
    if (codeLoad) codeLoad.addEventListener('click', function () {
      var box = $('[data-eld-codein]');
      var msg = $('[data-eld-codemsg]');
      var raw = (box.value || '').replace(/\s+/g, '');          // emails wrap the code
      if (!raw) { msg.textContent = 'Paste a code first.'; return; }
      if (loadCode(raw)) {
        msg.textContent = 'Rebuilt — opening the proof.';
        window.setTimeout(function () { draw(); openProof(); }, 160);
      } else {
        msg.textContent = 'That code could not be read. Copy the whole thing and try again.';
      }
    });
  }

  /* ------------------------------------------------------------------ init */
  function init() {
    root = document.querySelector('[data-eld]');
    if (!root) return;
    canvas = $('[data-eld-canvas]');
    ctx = canvas.getContext('2d');

    var t = $('[data-eld-tel]');
    if (t && CFG.phone) { t.textContent = CFG.phone; t.href = 'tel:' + CFG.phone.replace(/\s/g, ''); }
    if (CFG.heading) $('[data-eld-title]').textContent = CFG.heading;
    if (CFG.intro) $('[data-eld-intro]').textContent = CFG.intro;
    if (CFG.hideHeading) $('[data-eld-head]').style.display = 'none';

    bindSizes();
    bindInputs();
    bindCanvas();
    applyShapeUI();
    syncSizeChips();
    syncQtyChips();
    $('[data-eld-radiusval]').textContent = fmtMm(state.radius);
    renderLayout();
    renderLayers();
    renderProps();
    updateAdvice();
    renderRunInfo();
    draw();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(draw, 120);
    });

    root.setAttribute('data-eld-ready', 'true');
    restoreAfterPost();
    loadFromUrl();
  }

  /* Earlsmere clicking the proof link in an enquiry email: rebuild that customer's
     label and put the proof straight on screen. */
  function loadFromUrl() {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (err) { return; }

    var code = params.get('eld');
    if (!code) return;
    if (!loadCode(code)) return;

    if (params.get('proof') === '1') {
      // let the fonts settle so the proof matches what the customer saw
      window.setTimeout(function () { draw(); openProof(); }, 120);
    }
  }

  /* Rebuild a label from the design code that arrives with a quote email. */
  function loadCode(code) {
    var data;
    try { data = JSON.parse(decodeURIComponent(escape(atob(String(code).trim())))); }
    catch (err) { console.error('That design code could not be read.'); return false; }
    if (!data || !(data.v === 1 || data.v === 2)) { console.error('Unrecognised design code.'); return false; }

    ['w', 'h', 'shape', 'radius', 'material', 'adhesive', 'finish', 'bg', 'quantity'].forEach(function (k) {
      if (data[k] != null) state[k] = data[k];
    });

    /* Codes written before we offered a choice of face and adhesive carry neither.
       Fall back to what those labels actually were, rather than leaving whatever
       happened to be on screen — otherwise rebuilding an old proof shows the wrong
       material to whoever is checking it. */
    var CODE_DEFAULTS = { material: 'pp', adhesive: 'perm', finish: 'unlaminated', bg: '#ffffff' };
    Object.keys(CODE_DEFAULTS).forEach(function (k) {
      if (data[k] == null) state[k] = CODE_DEFAULTS[k];
    });
    Object.keys(state.env).forEach(function (k) {
      state.env[k] = !!(data.env && data.env[k]);
    });

    if (!LABELS.shape[state.shape]) state.shape = 'rect';
    if (state.finish === 'laminated') state.finish = 'gloss';   // pre-split design codes
    if (!LABELS.finish[state.finish]) state.finish = 'unlaminated';
    if (!LABELS.material[state.material]) state.material = 'pp';
    if (!LABELS.adhesive[state.adhesive]) state.adhesive = 'perm';
    if (state.shape !== 'rect') state.h = state.w;

    state.elements = (data.elements || []).map(function (e) {
      var copy = Object.assign({}, e);
      copy.id = 'e' + (++uid);
      if (copy.type === 'image' && copy.src) {
        var img = new Image();
        img.onload = draw;
        img.src = copy.src;
        copy._img = img;
        copy._small = copy.src;      // so a rebuilt design can be forwarded on intact
      }
      return copy;
    });
    selectedId = null;

    $$('[data-eld]').forEach(function (input) {
      var key = input.getAttribute('data-eld');
      if (state[key] == null) return;
      if (input.type === 'checkbox') input.checked = !!state[key];
      else input.value = state[key];
    });
    $$('input[name="eld-shape"]').forEach(function (r) { r.checked = r.value === state.shape; });
    $$('input[name="eld-finish"]').forEach(function (r) { r.checked = r.value === state.finish; });
    $$('input[name="eld-material"]').forEach(function (r) { r.checked = r.value === state.material; });
    $$('input[name="eld-adhesive"]').forEach(function (r) { r.checked = r.value === state.adhesive; });
    applyShapeUI();
    $('[data-eld-radiusval]').textContent = fmtMm(state.radius);
    $$('.eld__opt').forEach(function (lab) {
      var i = lab.querySelector('input');
      lab.classList.toggle('is-on', !!(i && i.checked));
    });
    $$('[data-eld-env]').forEach(function (c) {
      c.checked = !!state.env[c.getAttribute('data-eld-env')];
      var lab = c.closest('.eld__check');
      if (lab) lab.classList.toggle('is-on', c.checked);
    });
    syncSizeChips(); syncQtyChips(); renderLayout(); renderRunInfo();
    renderLayers(); renderProps(); updateAdvice(); renderSummary(); draw();

    /* A pasted design can use a pictogram from the ISO set, which lives in its own
       asset and normally only arrives when somebody opens the picker. Fetch it now,
       or the proof comes up with the customer's safety symbol missing. */
    var unknown = state.elements.some(function (e) { return e.type === 'symbol' && !symDef(e.sym); });
    if (unknown) loadSymbolLibrary(function () { renderLayers(); renderProps(); renderSummary(); draw(); });

    return true;
  }
  window.ELD_LOAD = loadCode;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
